﻿// @ts-ignore
const historyJs: Historyjs = <any>history;

namespace eXpress.dsp {
	const quantityQueryStringToModel = (quantityString: string) => {

		// partially copied from express.web.ui.website.creator.app\express\client\client.ts: quantityQueryStringToModel
		// I guess the site does not use the same core lib of js files.

		// Allow 2 formats
		// - just quantity number
		// - [AttributeCode]|[Quantity],[AttributeCode]|[Quantity], eg: s|2,xl|1
		if (quantityString && (quantityString.indexOf('|') >= 0 || quantityString.indexOf(',') >= 0)) {
			return quantityString.split(',').map(part => {
				const parts = part.split('|');
				const attribute = parts.length > 0 ? parts[0] : part;
				const quantity = parts.length > 0 ? parseInt(parts[1], 10) || 1 : 1;
				return new Quantity(attribute.toLowerCase(), quantity);
			});
		} else if (!isNaN(parseInt(quantityString, 10))) {
			return [new Quantity(undefined, parseInt(quantityString, 10))];
		}

		// incorrect format, no quantities
		return [];
	};

	/**
	 *
	 * @param {Quantity[]} quantities
	 * @param {IDesignDetail} designDetail
	 * @returns {boolean} true if valid.
	 */
	const validateQuantities = (quantities: Quantity[], designDetail: core.IDesignDetail) => {
		let acceptedAttributeCodes: (string | null)[];

		if (designDetail.attributeDetails && designDetail.attributeDetails.values) {
			// because lowercase everywhere.
			acceptedAttributeCodes = designDetail.attributeDetails.values.map(value => value.code.toLowerCase());
		} else {
			// literally: accept null as attribute value
			acceptedAttributeCodes = [null];
		}

		return quantities.every(quantity => {
			return acceptedAttributeCodes.indexOf(quantity.attribute) > -1;
		});
	};


	/* end IDesignDetail */

	export interface IDspAppDependencies {
		orderService: eXpress.services.OrderService;
		contentService: eXpress.services.ContentService;
	}

	enum AdvantageType {
		FixedAmountOnProduct,
		PercentageOnProduct
	}

	export class AppliedAdvantage {
		public description: string;
		public amount: number;
	}

	export class Quantity {
		public attribute: string | null;
		public quantity: number;

		public constructor(attribute: string | null = null, quantity = 0) {
			this.attribute = attribute;
			this.quantity = quantity;
		}

		public toString(): string {
			if (this.attribute)
				return this.attribute + '|' + this.quantity.toString();
			else
				return this.quantity.toString();
		}
	}

	export interface IDropDownData {
		productCode: string;
		predefinedProductName: string;
	}

	export class CurrentOption {
		public code: string;
		public price: number;
		public name: string;
		public optionGroup: string;
		public alternativeOptionGroup: string;
	}

	export class DspApp extends eXpress.core.CustomHtmlElementsApp {
		private context: core.IAppContext;
		private pageContext: core.IDspMultiProductPageContext;
		private headerHeight: number;
		private mainProductCategoryGroupCode?: string;
		private occasion?: string;
		private purpose?: string;
		private theme?: string;
		private options?: string;
		private crossSellFrom?: string;
		private preselectOccasion?: string;
		private occasionPackshot?: string;
		private purposePackshot?: string;
		private productCode: string[];
		private orientation?: string;
		private predefinedProductCategory: string[];
		private searchColor: string[];
		private imageCount: number[] = [];
		private price: number[] = [];
		private pageNumber: number;
		private pageSize: number;
		private ownDesign: boolean;
		private sortMethod?: string;
		private designGroup?: string;
		private gender?: string;
		private suppressScrollToAccordion: boolean;

		private currentOption1?: CurrentOption;
		private currentOption2?: CurrentOption;
		private currentQuantities: Quantity[] = [];

		private currentProductCode?: string;
		private currentPvc: string;
		private currentPredefinedProductName?: string;
		private currentProductName?: string;
		private currentCategoryList?: string;
		private currentCartId?: string;
		private currentAttribute?: string;

		private productHasQuantityBreakOnlyInMa: boolean;

		private defaultOptions: string[]; // This is the option(s) that should always be checked (when available)
		private optionGroup: string;

		private windowWidth: number;

		/** wrapper around AJAX request that will also return if it is the last requested result */
		private filterResultsRequester: utils.DetectLast<1, core.IGetDesignsResult>;

		protected services: services.Services;
		private orderService: services.OrderService;
		private contentService: services.ContentService;
		private contentManager: eXpress.core.ContentManager;

		private designs: { [pdp: string]: core.IDesign } = {};
		private totalDesignCount = 0;
		private designFilterChanged: boolean;
		private designFilterCount?: number;
		private deviceIsMobile = false;
		private previousProductGroupAlternatives: core.IProductAlternative[];
		private activeProductGroupAlternatives: core.IProductAlternative[] = [];

		private readonly body: JQuery;
		private readonly toggle: JQuery;
		private readonly dspItemList: JQuery;
		private readonly dspItemListFooter: JQuery;
		private readonly dspContentFilter: JQuery;
		private readonly filterChoice: JQuery;
		private readonly filterToggle: JQuery;
		private readonly acceptFilter: JQuery;
		private readonly acceptSorting: JQuery;
		private readonly showAllFilters: JQuery;
		private readonly deleteTagFiler: JQuery;
		private readonly deleteAllTagFilters: JQuery;
		private readonly filterSelectionTags: JQuery;
		private readonly filterSorting: JQuery;
		private readonly slider: JQuery;
		private readonly activeTag: JQuery;
		private readonly remark: JQuery;

		private constellations: { [key: string]: core.IConstellation[] } = {};

		/**
		 *
		 * @param {IDspAppDependencies} deps
		 * @param {services.Services} services
		 * @param {core.IAppContext} context
		 * @param {IDspMultiProductPageContext} pageContext
		 * @returns
		 */
		constructor(deps: IDspAppDependencies, services: services.Services, context: core.IAppContext, pageContext: core.IDspMultiProductPageContext) {
			super();
			this.context = context;
			this.pageContext = pageContext;
			this.services = services;
			this.orderService = deps.orderService;
			this.contentService = deps.contentService;
			this.contentManager = new core.ContentManager(this.contentService, GetCookie("slbls").toLowerCase() === "true");

			this.windowWidth = $(window).width() || 0;

			// loads initial filters & does a refresh
			this.mainProductCategoryGroupCode = eXpress.utils.getQueryStringParameter("pcg");

			if (this.pageContext.enableOccasionFilter) {
				this.occasion = eXpress.utils.getQueryStringParameter("occ");
			}
			if (this.pageContext.enablePurposeFilter) {
				this.purpose = eXpress.utils.getQueryStringParameter("purpose");
			}
			if (eXpress.utils.getQueryStringParameter("theme")) {
				this.theme = eXpress.utils.getQueryStringParameter("theme");
			}
			if (eXpress.utils.getQueryStringParameter("options")) {
				this.options = eXpress.utils.getQueryStringParameter("options");
			}
			if (eXpress.utils.getQueryStringParameter("crossSellFrom")) {
				this.crossSellFrom = eXpress.utils.getQueryStringParameter("crossSellFrom");
			}
			if (eXpress.utils.getQueryStringParameter("preocc")) {
				this.preselectOccasion = eXpress.utils.getQueryStringParameter("preocc");
			}

			if (eXpress.utils.getQueryStringParameter("p"))
				this.productCode = eXpress.utils.getQueryStringParameter("p").split(',');
			else
				this.productCode = [];

			if (this.pageContext.enableOrientationFilter) {
				this.orientation = eXpress.utils.getQueryStringParameter("or");
			}
			if (this.pageContext.enablePredefinedProductCategoryFilter) {
				if (eXpress.utils.getQueryStringParameter("ds"))
					this.predefinedProductCategory = eXpress.utils.getQueryStringParameter("ds").split(',');
				else
					this.predefinedProductCategory = [];
			}
			if (this.pageContext.enableColorFilter) {
				if (eXpress.utils.getQueryStringParameter("sc"))
					this.searchColor = eXpress.utils.getQueryStringParameter("sc").split(',');
				else
					this.searchColor = [];
			}
			if (this.pageContext.enableNumberOfPhotosFilter) {
				if (eXpress.utils.getQueryStringParameter("ic")) {
					const strImageCount = eXpress.utils.getQueryStringParameter("ic").split(',');
					this.imageCount = strImageCount.map(ic => parseInt(ic, 10))
						.filter(x => !isNaN(x));
				}
			}

			if (this.pageContext.enablePriceFilter) {
				if (eXpress.utils.getQueryStringParameter("pr")) {
					const strPrice = eXpress.utils.getQueryStringParameter("pr").split(',');
					this.price = strPrice.map(p => parseFloat(p))
						.filter(x => !isNaN(x));
				}
			}

			if (this.pageContext.enableGenderFilter) {
				this.gender = eXpress.utils.getQueryStringParameter("g");
			}

			this.currentProductCode = eXpress.utils.getQueryStringParameter("cpc");
			this.currentPredefinedProductName = eXpress.utils.getQueryStringParameter("cppn");
			this.currentCartId = eXpress.utils.getQueryStringParameter("cartid");
			this.currentAttribute = eXpress.utils.getQueryStringParameter("attr");
			if (!this.currentAttribute) {
				// The attribute was not passed through the attr parameter, get it from the pvc instead
				const tempPvc = eXpress.utils.getQueryStringParameter("pvc");
				if (tempPvc) {
					const pos = tempPvc.indexOf("_");
					if (pos >= 0)
						this.currentAttribute = tempPvc.substring(pos + 1).toLowerCase();
				}
			}
			this.sortMethod = eXpress.utils.getQueryStringParameter("sortmethod");
			this.designGroup = eXpress.utils.getQueryStringParameter("dg");

			// if no sortmethod, and this is a mobile device, set 'rankingMobile' as sortmethod.
			if (!this.sortMethod && eXpress.helpers.isMobileSize) {
				this.sortMethod = "rankingmobile";
			}

			this.ownDesign = false;
			if (eXpress.utils.getQueryStringParameter("cod") && eXpress.utils.getQueryStringParameter("cod").toLowerCase() === 'true')
				this.ownDesign = true;

			if (eXpress.utils.getQueryStringParameter("options"))
				this.defaultOptions = eXpress.utils.getQueryStringParameter("options").split(',');
			else
				this.defaultOptions = [];

			this.optionGroup = eXpress.utils.getQueryStringParameter("optiongroup");

			this.pageNumber = 1;
			if (this.pageContext.amountOfDesignsToFetch)
				this.pageSize = this.pageContext.amountOfDesignsToFetch;
			else
				this.pageSize = 40;

			this.currentOption1 = undefined;
			this.currentOption2 = undefined;

			// warning: until a designDetail is known, these cannot be validated
			this.currentQuantities = quantityQueryStringToModel(eXpress.utils.getQueryStringParameter('quantities'));

			this.headerHeight = eXpress.utils.getHeaderHeight();

			this.filterResultsRequester = new utils.DetectLast(() => {

				// We call the designs without filters if ownDesign is true.
				return this.services.selectionPage.getDesignsAsync(
					this.context.pointOfSaleId,
					this.context.languageCode,
					this.mainProductCategoryGroupCode,
					this.ownDesign ? undefined : this.occasion,
					this.ownDesign ? undefined : this.purpose,
					this.ownDesign ? [] : this.productCode,
					this.ownDesign ? undefined : this.orientation,
					this.ownDesign ? [] : this.predefinedProductCategory,
					this.ownDesign ? [] : this.searchColor,
					this.ownDesign ? [] : this.imageCount,
					this.ownDesign ? [] : this.price,
					this.pageNumber,
					this.pageSize,
					this.defaultOptions,
					this.optionGroup,
					this.ownDesign,
					this.sortMethod,
					this.designGroup,
					this.ownDesign ? undefined : this.gender,
					utils.getQueryStringParameter('debug') ? true : false,
					this.preselectOccasion
				);
			});


			this.dspItemList = $(".dsp-item-list");
			this.dspItemListFooter = $(".dsp-item-list-footer");
			this.dspContentFilter = $(".dsp-content-filter");
			this.filterChoice = $(".filter-choice");
			this.filterToggle = $(".filter-toggle");
			this.acceptFilter = $(".accept-filter");
			this.acceptSorting = $(".accept-sorting");
			this.showAllFilters = $(".show-all-filters");
			this.deleteTagFiler = $(".tag-delete-this-filter");
			this.deleteAllTagFilters = $(".tag-delete-all-filters");
			this.filterSelectionTags = $(".filter-selection-tags");
			this.filterSorting = $(".filter-sorting");
			this.slider = $(".slider");
			this.activeTag = $('.tag-active');
			this.remark = $(".remark");
			this.toggle = $(".toggle");
			this.body = $("body");
		}

		public start(): void {
			this.clear();

			this.loadLabels()
				.always(() => this.loadAdditionalIcons())
				.always(() => {
					core.showLoadingDialogAsync (
						this.fetchPageAsync(1)
							.then(designKeys => {
								if (designKeys) {
									this.addItems(designKeys, true);
								}

								this.hideAndShowForOwnDesign();
								this.addHandlers();
							})
					);
				});
		}

		public loadAdditionalIcons() {
			return this.contentManager.getIconsByNameAsync(["paintbrush"]);
		}

		public loadLabels() {
			return this.contentManager.getLabelsAsync (
				[
					"Label.DspMulti.ChangeBackground.OpenDSP",
					"Label.DspMulti.ChangeBackground.ListDSP",
					"Label.DesignSelection.Apply",
					"Label.DesignSelection.Back",
					"Label.DesignSelection.AllFilters",
					"Label.DesignSelection.HideFilters",
					"Label.DesignSelection.FilterAmount",
					"Label.DspMulti.PriceStartingFrom"
				]
			);
		}

		private showCurrentDetail(): void {
			if (this.currentProductCode && this.currentPredefinedProductName) {
				// Check if it is already on the page, if not, add it as the first
				const $existingTile = $(".dsp-item-list article[data-productcode='" + this.currentProductCode + "'][data-predefinedproductname='" + this.currentPredefinedProductName + "']");
				if ($existingTile.length > 0) {
					if (!$existingTile.hasClass('disabled'))
						this.showDetailClick($existingTile, false, true);
				}
				else {
					const $template = $('.template-container .item');
					const $new = $template.clone();


					this.GetOrLoadDesignAsync(this.currentPredefinedProductName, this.currentProductCode)
						.then((design) => {
							if (!design.temporaryUnavailable) {
								const $newTile = this.createTile(design, $new, false, eXpress.services.DSPType.ListDSP);
								this.dspItemList.prepend($newTile);
								this.showDetailClick($newTile, false, true);
							}
						});
				}
			}
		}

		protected addHandlers(): void {
			super.addHandlers();

			$(window).resize(() => {
				//if filtercontainer is open and has property position = 'fixed' then deviceIsMobile = true
				this.deviceIsMobile = $(".filter-container.open").css("position") === "fixed";

				const newWindowWidth = $(window).width() || 0;
				if (this.windowWidth !== newWindowWidth) {
					this.windowWidth = newWindowWidth;
					this.repositionDetail();
				}
			});

			this.dspItemList.on('click', '.item:not(.disabled) .a-icon', e => {
				this.stopBubble(e, true);
				const $target = $(e.currentTarget);
				if ($target.parent().is('.item-icons-center')) {
					this.showDetailClick($target.closest('.item'), false);
				} else {
					const $tile = $target.closest('article');
					this.hideDetailClick(false, false);
					this.changeTileClicked($tile, $target.attr("data-predefinedproductname")!, $target.attr("data-productcode")!);
				}

			});

			this.dspItemListFooter.on('click', 'button.main', () => this.showMore());

			/* Filters & Sorting */

			$(".toggle.main").on('click', () => this.body.removeClass("filtering-scrolling"));

			$(document).on("click", ".filter-toggle", () => {
				if (this.filterChoice.hasClass("open")) {
					this.body.addClass("filtering-scrolling");
					$('.dsp-result-bottom span').html(this.contentManager.getLabel("Label.DesignSelection.Back", "Back"));
				}
			});

			$(document).on("click", '#layerback, #layerback', e => this.stopBubble(e, false));

			this.showAllFilters.on("click", e => {
				const $target = $(e.currentTarget);
				$target.toggleClass("show-all-filters hide-all-filters");
				this.filterChoice.toggleClass("all-filters-active");
				$target.find(".show-all-filters-text").html($target.hasClass('show-all-filters')
					? this.contentManager.getLabel("Label.DesignSelection.AllFilters", "All filters")
					: this.contentManager.getLabel("Label.DesignSelection.HideFilters", "Hide"));
				$(".multiselect").each(function () {
					if ($(this).hasClass("hidden"))
						$(this).toggleClass("hidden temp-visible");
					else if ($(this).hasClass("temp-visible"))
						$(this).toggleClass("temp-visible hidden");
				});
			});

			this.body.on("click", e => {
				const $target = $(e.currentTarget).find('.selectBox.open');
				if ($target && this.designFilterChanged) {
					this.acceptFiltering($target);
					this.designFilterChanged = false;
				}
			});

			this.toggle.on("click", () => {
				this.filterToggle.toggleClass("open");
				this.filterChoice.toggleClass("open");
				$(".filter-container").toggleClass("open");

				$(".main.small.filter-toggle").prop('disabled', false);
				$(".button.own-designs").show();
			});

			this.acceptFilter.on("click", e => {
				this.stopBubble(e, true);
				if (this.designFilterChanged)
					this.acceptFiltering($(e.currentTarget));
				this.designFilterChanged = false;
			});

			$(".filter-choice .checkboxes .slider").on("click", e => this.stopBubble(e, false));

			$(".filter-choice .selectBox").on("click", e => {
				const $requester = $(e.target);
				if ($requester.hasClass("open"))
					e.preventDefault();
				else if ($(".filter-container").hasClass("open") && !$requester.hasClass("tag-delete-this-filter"))
					$('.accept-filter,.accept-sorting').html(this.contentManager.getLabel("Label.DesignSelection.Back"));
			});

			$(".multiselect:not(.filter-sorting) > div.selectbox-choices").on('click', e => {
				if (!$(e.target).is('.accept-filter')) {
					e.preventDefault();
					e.stopPropagation();
				}
			});

			$(".filter-choice .checkboxes label").on("click", e => {
				this.stopBubble(e, false);
				const $target = $(e.currentTarget);
				const $parent = $target.closest('.selectbox-choices');
				const $multiselect = $(e.target).closest('.multiselect');
				const isSorting = $multiselect.hasClass("filter-sorting");
				const filter = $multiselect.attr('data-sp-selectcategory')!;
				const value = $target.attr('data-sp-filter-tag')!;
				let itemsChecked = false;

				if ($parent.hasClass('selectbox-choices-radio')) {
					// Single select mode
					if (!$target.hasClass('checked')) {
						// Uncheck all others
						itemsChecked = true;
						$parent.find('label').removeClass('checked');
						$target.addClass('checked');
						if (!this.deviceIsMobile && !isSorting)
							this.changeFilter(filter, value);
						else if (isSorting)
							this.changeSorting(value);
					}
					else {
						itemsChecked = false;
						$parent.find('label').removeClass('checked');
						if (!this.deviceIsMobile && !isSorting)
							this.changeFilter(filter, '');
						else if (isSorting)
							this.changeSorting(value);
					}
					if (this.deviceIsMobile)
						this.loadFilterCount($multiselect);
					else {
						$parent.hide();
						$('.selectBox').removeClass('open');
					}
				}
				else {
					// Multi select mode
					$target.toggleClass('checked');
					const values = [] as string[];
					$parent.find('label.checked').each(function () {
						values.push($(this).attr('data-sp-filter-tag')!);
					});
					itemsChecked = values.length > 0;

					// List not closed, update filter Count
					this.loadFilterCount($multiselect);
				}
				this.setFilterState($multiselect, itemsChecked);
			});

			this.deleteTagFiler.on('click', e => {
				e.stopPropagation();
				const $target = $(e.currentTarget);
				const filterName = $target.closest('.multiselect').attr('data-sp-selectcategory');
				const $parent = $('.multiselect[data-sp-selectcategory="' + filterName + '"]');
				const checkedLabels = $($parent).find(".checked").length;
				let changedSlider = false;
				if ($parent.hasClass('multiselect-imagecount') || $parent.hasClass('multiselect-price')) {
					const $slider = $parent.find('.slider-range');
					const min = parseFloat($parent.find('.slider-min').attr('data-value')!);
					const max = parseFloat($parent.find('.slider-max').attr('data-value')!);

					if ($parent.hasClass('multiselect-imagecount')) {
						if ($parent.find('.slider-min input').val() !== min.toString() ||
							$parent.find('.slider-max input').val() !== max.toString()) {
							changedSlider = true;
						}
						$parent.find('.slider-min input').val(min.toString());
						$parent.find('.slider-max input').val(max.toString());
					}
					else {
						if ($parent.find('.slider-min input').val() !== utils.displayPrice(min, false, false, this.pageContext) ||
							$parent.find('.slider-max input').val() !== utils.displayPrice(max, false, false, this.pageContext)) {
							changedSlider = true;
						}
						$parent.find('.slider-min input').val(utils.displayPrice(min, false, false, this.pageContext));
						$parent.find('.slider-max input').val(utils.displayPrice(max, false, false, this.pageContext));
					}
					$slider.slider("values", 0, min);
					$slider.slider("values", 1, max);
					$parent.find(".selectBox > span.filter-info").html("");
					$(".cat-" + filterName + " span.value").html("");
				}
				else {
					$parent.find('label.checked').each(function () {
						$(this).removeClass('checked');
					});
				}
				this.setFilterState($parent, false);

				if (checkedLabels > 0 || changedSlider) {
					this.designFilterChanged = true;
					$('.accept-filter,.accept-sorting').html(this.contentManager.getLabel("Label.DesignSelection.Apply", "Apply"));
				}
			});

			this.deleteAllTagFilters.on('click', () => {
				$('.filter-choice label.checked').removeClass('checked');
				this.resetSliders();
				$('.filter-selection-tags .tag-active').not('.empty').not('.tag-delete-all-designs').remove();
				this.removeFilters();
			});

			this.filterSelectionTags.on('click', '.tag-active', e => {
				const $target = $(e.currentTarget);
				if ($target.hasClass('tag-delete-all-designs')) {
					// Removes the selected state
					$('.filter-choice label.checked').removeClass('checked');
					this.resetSliders();
					$('.filter-selection-tags .tag-active').not('.empty').not('.tag-delete-all-designs').remove();
					this.removeFilters();
				}
				else {
					const filterName = $target.attr('data-sp-selectcategory')!;
					const filterValue = $target.attr('data-sp-selecttag');
					const $parent = $('.multiselect[data-sp-selectcategory="' + filterName + '"]');
					const $filter = $parent.find('label[data-sp-filter-tag="' + filterValue + '"]');
					const values = [] as string[];

					if ($parent.hasClass('multiselect-imagecount') || $parent.hasClass('multiselect-price')) {
						const $slider = $parent.find('.slider-range');
						const min = parseFloat($parent.find('.slider-min').attr('data-value')!);
						const max = parseFloat($parent.find('.slider-max').attr('data-value')!);
						if ($parent.hasClass('multiselect-imagecount')) {
							$parent.find('.slider-min input').val(min.toString());
							$parent.find('.slider-max input').val(max.toString());
						}
						else {
							$parent.find('.slider-min input').val(utils.displayPrice(min, false, false, this.pageContext));
							$parent.find('.slider-max input').val(utils.displayPrice(max, false, false, this.pageContext));
						}
						$slider.slider("values", 0, min);
						$slider.slider("values", 1, max);
						$target.remove();
						this.changeFilter(filterName, []);
					}
					else {
						$filter.removeClass('checked');
						$parent.find('label.checked').each(function () {
							values.push($(this).attr('data-sp-filter-tag')!);
						});
						this.changeFilter(filterName, values);
					}
					this.setFilterState($parent, values && values.length > 0);
					$target.remove();
				}
			});

			this.slider.each((index, element) => {
				const $element = $(element);
				const $multiselect = $element.closest('.multiselect');
				const min = parseFloat($element.find('.slider-min').attr('data-value')!);
				const max = parseFloat($element.find('.slider-max').attr('data-value')!);
				let startMin = min;
				let startMax = max;
				const startAttr = $element.attr('data-start');
				if (startAttr) {
					const startSplit = startAttr.split(',');
					startMin = parseFloat(startSplit[0]);
					startMax = parseFloat(startSplit[1]);
				}

				const step = parseFloat($element.attr('data-step')!);
				const minInput = $element.find('.slider-min input');
				const maxInput = $element.find('.slider-max input');
				if ($multiselect.attr('data-sp-selectcategory') === 'price') {
					minInput.val(utils.displayPrice(startMin, false, false, this.pageContext));
					maxInput.val(utils.displayPrice(startMax, false, false, this.pageContext));
				}
				else {
					minInput.val(startMin);
					maxInput.val(startMax);
				}

				const $slider = $element.find('.slider-range');
				$slider.slider({
					range: true,
					step: step,
					min: min,
					max: max,
					values: [startMin, startMax],
					change: (_event, ui) => {
						if (ui.handle && ui.values) {
							const $slider = $(ui.handle).closest('.slider');
							const $multiselect = $(ui.handle).closest('.multiselect');
							if ($multiselect.attr('data-sp-selectcategory') === 'price') {
								$slider.find('.slider-min input').val(utils.displayPrice(ui.values[0], false, false, this.pageContext));
								$slider.find('.slider-max input').val(utils.displayPrice(ui.values[1], false, false, this.pageContext));
							}
							else {
								$slider.find('.slider-min input').val(ui.values[0]);
								$slider.find('.slider-max input').val(ui.values[1]);
							}
							this.setFilterState($multiselect, min !== ui.values[0] || max !== ui.values[1]);
						}
					},
					slide: (_event, ui) => {
						if (ui.handle && ui.values) {
							const $slider = $(ui.handle).closest('.slider');
							const $multiselect = $(ui.handle).closest('.multiselect');
							if ($multiselect.attr('data-sp-selectcategory') === 'price') {
								$slider.find('.slider-min input').val(utils.displayPrice(ui.values[0], false, false, this.pageContext));
								$slider.find('.slider-max input').val(utils.displayPrice(ui.values[1], false, false, this.pageContext));
							}
							else {
								$slider.find('.slider-min input').val(ui.values[0]);
								$slider.find('.slider-max input').val(ui.values[1]);
							}
						}
					}
				});

				maxInput.on('change', (ev) => {
					let maxvalue = maxInput && maxInput.val() && maxInput.val()!.toString().match('^[0-9]+([,.][0-9]*)?$') ? parseFloat(maxInput.val()!.toString().replace(',', '.')) : max;
					const minvalue = minInput && minInput.val() && minInput.val()!.toString().match('^[0-9]+([,.][0-9]*)?$') ? parseFloat(minInput.val()!.toString().replace(',', '.')) : min;
					if (maxvalue > max)
						maxvalue = max;

					if (maxvalue < minvalue)
						maxvalue = minvalue;

					$slider.slider('values', [minvalue, maxvalue]);
					this.designFilterChanged = true;
				});
				minInput.on('change', (ev) => {
					const maxvalue = maxInput && maxInput.val() && maxInput.val()!.toString().match('^[0-9]+([,.][0-9]*)?$') ? parseFloat(maxInput.val()!.toString().replace(',', '.')) : max;
					let minvalue = minInput && minInput.val() && minInput.val()!.toString().match('^[0-9]+([,.][0-9]*)?$') ? parseFloat(minInput.val()!.toString().replace(',', '.')) : min;

					if (minvalue < min)
						minvalue = min;

					if (minvalue > maxvalue)
						minvalue = maxvalue;

					$slider.slider('values', [minvalue, maxvalue]);
					this.designFilterChanged = true;
				});
			});

			this.filterSorting.on('click', 'label', e => {
				$('.filter-sorting label').removeClass('checked');

				const $target = $(e.currentTarget);
				$target.addClass('checked');
				this.changeSorting($target.attr('data-sp-filter-tag')!);
			});

			this.acceptSorting.on("click", () => {
				const $target = $('.filter-sorting .selectbox-choices .checked');
				this.changeSorting($target.attr('data-sp-filter-tag')!);
			});

			this.filterChoice.on("click", ".selectBox", e => {
				// Get Selected Filter element
				const $multiselect = $(e.target).closest('.multiselect');
				this.loadFilterCount($multiselect);
			});

			/* Own designs */

			this.dspContentFilter.on('click', '.button.own-designs', () => this.toggleOwnDesign());

			this.dspContentFilter.on('click', '.button.back-to-designs', () => this.toggleOwnDesign());

			/* Detail stuff */

			this.dspItemList.on('click', '.item:not(.disabled)', e => this.showDetailClick($(e.currentTarget), false));

			$('.item-detail .dsp-next').on('click', () => {
				if (window.dataLayer[0].datalayerversion >= '2022-06') {
					const gtmData = {
						eventCategory: "Design Selection",
						eventAction: this.currentProductName,
						eventLabel: this.currentPredefinedProductName,
						eventProduct: this.currentProductCode,
						event: 'eec.detail',
						ecommerce: {
							detail: {
								actionField: {
								},
								products: [{
									id: this.currentProductCode,
									variant: this.currentPvc,
									name: this.currentProductName,
									category: this.currentCategoryList,
									dimension11: this.currentPredefinedProductName
								}]
							}
						}
					};

					const dataLayer = window.dataLayer || [];
					dataLayer.push(gtmData);
				}
			});

			$('.item-detail .close').on('click', () => this.hideDetailClick(true));

			this.dspItemList.on('click', '.item-detail-choice .a-icon, .item-detail .item-detail-choice .item-constellations > span:not(.active)', (e) => {
				e.preventDefault();
				e.stopPropagation();
				this.showDetailClick($(e.currentTarget), true);
			});

			// OpenDsp => alt color / alt product dropdown
			this.dspItemList.on('click', '.item-detail .multiselect-alternatives .selectbox-choices label', (e) => {
				e.preventDefault();
				e.stopPropagation();
				this.showDetailClick($(e.currentTarget), true);
			});

			this.dspItemList.on('click', '.item-detail .item-detail-choice .item-options span', (e) => {
				e.preventDefault();
				e.stopPropagation();
				this.changeOptions($(e.currentTarget));
			});

			// OpenDsp => Option Dropdown
			this.dspItemList.on("click", '.item-detail .item-options .multiselect .selectbox-choices label', (e) => {
				e.preventDefault();
				e.stopPropagation();
				this.changeDspOptions($(e.currentTarget));
			});

			this.slider.on("slidestop", () => {
				this.designFilterChanged = true;
				this.acceptFilter.html(this.contentManager.getLabel("Label.DesignSelection.Apply"));
			});

			$('.content-outer label').on("click", () => {
				this.designFilterChanged = true;
				$('.accept-filter,.accept-sorting').html(this.contentManager.getLabel("Label.DesignSelection.Apply"));
			});

			$(document).on("keypress", ".item-quantity input,input.quantity-input", e => window.PreventInvalidInput($(e.currentTarget), /^[1-9]\d*$/, e));

			$(document).on("keyup", ".item-quantity input", e => this.changeQuantity($(e.currentTarget), false));

			$(document).on("keyup", "input.quantity-input", e => this.changeQuantity($(e.currentTarget), true));

			$(document).on("blur", ".item-quantity input", e => {
				const $target = $(e.currentTarget);
				$target.val((parseInt($target.val()!.toString(), 10) || 1).toString());
			});

			$(document).on("blur", "input.quantity-input", e => {
				const $target = $(e.currentTarget);
				$target.val((parseInt($target.val()!.toString(), 10) || '').toString());
			});

			$(document).on("click", ".item-attributes .counter", e => this.changeQuantityPlusMin($(e.currentTarget)));

			this.dspItemList.on("click", '.item-detail .item-attributes .multiselect .selectbox-choices label', e => {
				this.changeDspAttribute($(e.currentTarget));
			});

			this.dspItemList.on("click", '.item-detail .dsp-next', () => this.validateInput());

			this.dspItemList.on('click', '.icon-info', e => {
				e.preventDefault();
				e.stopPropagation();
				$('.item-detail .price-detail-list').toggle();
			});

			this.dspItemList.on('click', '.price-detail-list .close', e => {
				e.preventDefault();
				e.stopPropagation();
				$('.item-detail .price-detail-list').toggle();
			});

			$(document).on("click", (e) => {
				if (e.target instanceof HTMLElement)
					if (!(e.target as HTMLElement).closest('.item-detail .price-detail-list'))
						$('.item-detail .price-detail-list').hide();
			});
		}

		private setFilterState($select: JQuery, hasItemsSelected: boolean): void {
			$select.find(".selectBox").toggleClass("hasItemsSelected", hasItemsSelected);
		}

		private resetSliders() {
			const $sliderParents = $('.filter-choice .multiselect').has('.slider');
			for (let i = 0; i < $sliderParents.length; i++) {
				const $sliderParent = $($sliderParents[i]);

				const min = parseFloat($sliderParent.find('.slider-min').attr('data-value')!);
				const max = parseFloat($sliderParent.find('.slider-max').attr('data-value')!);

				const $sliderMinInput = $sliderParent.find('.slider-min input');
				const $sliderMaxInput = $sliderParent.find('.slider-max input');

				const $slider = $sliderParent.find('.slider-range');
				$slider.slider("values", 0, min);
				$slider.slider("values", 1, max);

				if ($sliderParent.hasClass('multiselect-imagecount')) {
					$sliderMinInput.val(min.toString());
					$sliderMaxInput.val(max.toString());
				}
				else {
					$sliderMinInput.val(utils.displayPrice(min, false, false, this.pageContext));
					$sliderMaxInput.val(utils.displayPrice(max, false, false, this.pageContext));
				}
				this.setFilterState($sliderParent, false);
			}
		}

		private acceptFiltering($target: JQuery) {
			const $el = $target.closest('div.multiselect[data-sp-selectcategory]');
			if ($el.length > 0) {
				const filter = $el.attr('data-sp-selectcategory')!;

				if ($el.find('.selectbox-choices-slider').length === 0) {
					const stringValues: string[] = [];

					$el.find('label.checked').each((indx, el) => {
						stringValues.push($(el).attr('data-sp-filter-tag')!);
					});

					this.changeFilter(filter, stringValues);

				} else {

					let numberValues: number[] = [];

					const $slider = $el.find('.slider');
					const $sliderMin = $slider.find('.slider-min');
					const $sliderMax = $slider.find('.slider-max');

					const min = +$sliderMin.attr('data-value')!;
					const max = +$sliderMax.attr('data-value')!;

					const minSelected = +$sliderMin.find('input').val()!.toString().replace(",", ".");
					const maxSelected = +$sliderMax.find('input').val()!.toString().replace(",", ".");

					numberValues.push(minSelected < min ? min : minSelected, maxSelected > max ? max : maxSelected);

					if ($slider.hasClass('slider-imagecount')) // image-count must be integer number
						numberValues = numberValues.map(v => parseInt(v.toString(), 10));

					this.changeFilter(filter, numberValues);
				}
			}
		}

		private loadFilterCount($multiselect: JQuery): void {
			if (this.pageContext.disableFilterCounters)
				return;

			// already loaded?
			if (!$multiselect.attr('data-filter-count')) {

				// Mark loading
				$multiselect.attr('data-filter-count', '1');

				// Get filter Enum
				let filterCountName: services.DesignFilterCountName | undefined = undefined;
				if ($multiselect.hasClass('multiselect-occasion')) filterCountName = eXpress.services.DesignFilterCountName.Occasion;
				else if ($multiselect.hasClass('multiselect-purpose')) filterCountName = eXpress.services.DesignFilterCountName.Purpose;
				else if ($multiselect.hasClass('multiselect-productcode')) filterCountName = eXpress.services.DesignFilterCountName.Productcode;
				else if ($multiselect.hasClass('multiselect-orientation')) filterCountName = eXpress.services.DesignFilterCountName.Orientation;
				else if ($multiselect.hasClass('multiselect-predefinedproductcategory')) filterCountName = eXpress.services.DesignFilterCountName.Predefinedproductcategory;
				else if ($multiselect.hasClass('multiselect-searchcolor')) filterCountName = eXpress.services.DesignFilterCountName.Searchcolor;

				if (filterCountName !== undefined) {
					// Request new Filter Count
					this.getFilterCountAsync(filterCountName).then(result => {
						// Update UI with results
						const $label = $multiselect.find('.selectbox-choices label');
						this.updateFilterCount($label, result);
					});
				}
			}
		}

		private getFilterCountAsync(designFilter: services.DesignFilterCountName) {

			return this.services.selectionPage.GetDesignFilterCount(
				this.context.pointOfSaleId,
				this.context.languageCode,
				designFilter,
				this.ownDesign ? undefined : this.occasion,
				this.ownDesign ? undefined : this.purpose,
				this.mainProductCategoryGroupCode,
				this.ownDesign ? [] : this.productCode,
				this.ownDesign ? undefined : this.orientation,
				this.ownDesign ? [] : this.predefinedProductCategory,
				this.ownDesign ? [] : this.searchColor,
				this.ownDesign ? [] : this.imageCount,
				this.ownDesign ? [] : this.price,
				this.ownDesign ? undefined : this.gender,
				this.ownDesign);
		}

		private clearFilterCounts() {
			this.filterChoice
				.find('.multiselect-purpose, .multiselect-orientation, .multiselect-occasion, .multiselect-productcode, .multiselect-predefinedproductcategory, .multiselect-searchcolor')
				.removeAttr('data-filter-count')
				.find('.selectbox-choices label')
				.find('.filter-amount')
				.html('');
		}

		private clear(): void {
			$('.dsp-item-list .item').remove();
			$('.dsp-item-list .no-designs-found').remove();
			$('.dsp-item-list .item-detail').removeClass('visible');
			this.designs = {};
		}

		private showMore() {
			this.hideDetailClick(false);
			window.ShowLoadingDialog();
			this.fetchPageAndRenderAsync(this.pageNumber + 1, false);
		}

		private fetchPageAsync(pageNumber: number): JQueryPromise<undefined | string[]> {
			this.pageNumber = pageNumber;
			$('.dsp-item-list-footer button.main').addClass('loading');

			// Only clear on new search
			if (pageNumber === 1) {
				this.clearFilterCounts();
			}

			return this.filterResultsRequester.execAsync(1).then(res => {
				// Prevent race conditions by only updating with last request
				if (res.isLastRequested) {
					const designResult = res.value;
					this.preselectOccasion = '';

					const newDesignKeys = this.saveDesigns(designResult);

					return this.loadIconsAsync(newDesignKeys)
						.then(() => newDesignKeys);
				}

				// this is not the last request result
				return $.Deferred<undefined>().resolve(undefined).promise();
			});
		}

		private fetchPageAndRenderAsync(pageNumber: number, showCurrentDetail = false): void {
			this.fetchPageAsync(pageNumber)
				.then(designKeys => {
					if (designKeys) {
						this.addItems(designKeys, showCurrentDetail);
					}
				});
		}

		/* WEB-5324: Hide constellations on open DSP
		private loadConstellations(productCode: string, pdp: string): JQueryPromise<core.IConstellation[]> {
			return this.services.selectionPage.getConstellationsAsync(this.context.pointOfSaleId, this.context.languageCode, productCode, pdp)
				.then(res => {
					this.saveConstellations(res, productCode);
					return res;
				});
		}

		private getOrLoadConstellations(productCode: string, pdp: string): JQueryPromise<core.IConstellation[]> {
			const constellations = this.constellations[productCode];
			if (constellations)
				return $.Deferred<core.IConstellation[]>().resolve(constellations).promise();
			else
				return this.loadConstellations(productCode, pdp);
		}
		*/

		private saveConstellations(constellations: core.IConstellation[], productCode: string) {
			const key = productCode.toLowerCase();
			const check = this.constellations[key];
			if (!check) {
				this.constellations[key] = constellations;
				constellations.forEach(c => {
					const code = c.productCode.toLowerCase();
					if (!this.constellations[code])
						this.constellations[code] = constellations;
				});
			}
		}

		private getIconUrls(designKeys: string[]): string[] {
			let iconsurls: (string | undefined)[] = [];
			designKeys.forEach(designKey => {
				const design = this.designs[designKey];
				if (design) {

					//alt color
					if (design.alternativeColors && design.alternativeColors.length > 1)
						iconsurls = [...iconsurls, ...design.alternativeColors
							.filter((val, index) => val.designVariant
								&& val.designVariant.icon
								&& iconsurls.indexOf(val.designVariant.icon) !== index)
							.map(ac => ac.designVariant!.icon)];

					// alt product
					if (design.productAlternativesGroups)
						iconsurls = [...iconsurls, ...design.productAlternativesGroups
							.reduce((p, c) => [...p, ...c.productAlternatives
								.map(pa => { if (iconsurls.indexOf(pa.icon) < 0) return pa.icon; })], [])];
				}
			});

			return iconsurls.filter(url => !!url) as string[];
		}

		private loadIconsAsync(designKeys: string[], urls: string[] = []): JQueryPromise<StringKeyValuePair[]> {
			const iconUrls = [...this.getIconUrls(designKeys), ...urls];
			return this.contentManager.getIconsAsync(iconUrls);
		}

		private saveDesign(design: core.IDesign): string {
			const key = design.predefinedProductName.toLowerCase() + ":" + design.productCode.toLowerCase();
			this.designs[key] = { ...this.designs[key], ...design };
			return key;
		}

		private saveDesigns(designResult: core.IGetDesignsResult): string[] {

			this.totalDesignCount = designResult.designCount;
			this.designFilterCount = designResult.designFilterCount;

			return designResult.designs.map(d => this.saveDesign(d));

		}

		private GetOrLoadDesignAsync(predefinedProductName: string, productCode: string): JQueryPromise<core.IDesign> {
			const key = predefinedProductName.toLowerCase() + ":" + productCode.toLowerCase();
			const design = this.designs[key];
			if (design)
				return $.Deferred<core.IDesign>().resolve(design).promise();
			else {
				return this.services.selectionPage.getDesign(this.context.pointOfSaleId,
					this.context.languageCode,
					predefinedProductName,
					productCode,
					this.ownDesign ? undefined : this.occasion,
					this.ownDesign ? undefined : this.purpose,
					this.defaultOptions,
					this.optionGroup).then(design => {
						this.saveDesign(design);
						return design;
					});
			}
		}

		private createOpenDspDropDown($original: JQuery, list: string[], code: string, data: IDropDownData[], top: string) {

			const $dropdown = $original.find('.dropdownlist');
			const $template = $dropdown.find('.multiselect-alternatives');

			if (list.length > 1) {
				const $new = $template.clone();
				$new.attr('data-code', code);

				// set default text dropdown
				$new.find('.label').html(top);

				const $subContainer = $new.find('.selectbox-choices').detach();
				const $subTemplate = $subContainer.find('label');
				$subContainer.empty();

				for (let i = 0; i < list.length; i++) {
					const $subNew = $subTemplate.clone();
					const label = list[i];
					$subNew.html(label);
					$subNew.attr("data-productcode", data[i].productCode);
					$subNew.attr("data-predefinedproductname", data[i].predefinedProductName);
					$subContainer.append($subNew);
				}

				return $new.append($subContainer);
			}
		}

		private createIcon($newIcon: JQuery, dspBehavior: eXpress.services.InDsp, dspType: eXpress.services.DSPType, iconData?: eXpress.services.IIcon, alternativeColor?: string): JQuery | undefined {

			if (iconData && iconData.IconSvg) {
				// modify type icon
				switch (dspBehavior) {
					case eXpress.services.InDsp.IconsSmall:
						$newIcon.addClass("a-icon--small");
						break;
					case eXpress.services.InDsp.Icons:
						$newIcon.addClass("a-icon--big");
						break;
					case eXpress.services.InDsp.IconsWithText:
						$newIcon.addClass("a-icon--with-label");
						$newIcon.append("<span class='a-icon__label'>" + iconData.Label + "</span>");
						break;
					default:

				}

				const icon = this.contentManager.getIconByKey(iconData.IconSvg);
				if (!icon) return undefined;

				// set icon (product-alt always an icon)
				$newIcon.find('.a-icon__symbol').append(icon);

				// if is icon for listDsp => smallest
				if (dspType === eXpress.services.DSPType.ListDSP)
					$newIcon.addClass("a-icon--list");

				// set color if specified
				if (iconData.IconColorCode) {
					$newIcon.css('color', iconData.IconColorCode);

					// if white => set outline
					if (iconData.IconSvg && iconData.IconColorCode.toLowerCase() === "white" || iconData.IconColorCode.toLowerCase() === "#ffffff")
						$newIcon.addClass("a-icon--outline");
				}

				// OverlayColor => small round overlay
				if (iconData.IconOverLayColorCode) {
					$newIcon.append("<span class='a-icon__overlay'></span>");
					$newIcon.find(".a-icon__overlay").css("color", iconData.IconOverLayColorCode);

					// if white => set outline
					if (iconData.IconSvg && iconData.IconOverLayColorCode.toLowerCase() === "white" || iconData.IconOverLayColorCode.toLowerCase() === "#ffffff")
						$newIcon.find(".a-icon__overlay").addClass("a-icon__overlay--outline");

				}

				// Rotation
				if (iconData.Orientation && iconData.Orientation === eXpress.services.Orientation.Vertical)
					$newIcon.addClass("a-icon--rotated");

			} else {

				//check if hex
				if (!alternativeColor || alternativeColor.indexOf("#") < 0)
					return undefined;

				// if no designVariant => just alt-color
				$newIcon.css('color', alternativeColor);

				// if variant for listdsp => must be an small icon
				if (dspType === eXpress.services.DSPType.ListDSP) {
					$newIcon.addClass("a-icon--small");
					$newIcon.addClass("a-icon--list");
				}

				// if alt-color is white => need an outline
				if (alternativeColor === "white" || alternativeColor.toLowerCase() === "#ffffff") {
					$newIcon.addClass("a-icon--outline");
				}
			}

			return $newIcon;
		}

		private createTileAlternativeColors($original: JQuery, design: core.IDesign, container: string, dspType: eXpress.services.DSPType): boolean {

			// Template
			const $colorList: JQuery = $original.find('.item-icons-left');
			const $iconTemplate = $colorList.find('.a-icon').detach();
			const $itemToInsertBefore = $colorList.next();
			$colorList.detach();
			$colorList.empty();

			const product = design.product;
			const designVariantInDSP: eXpress.services.InDsp = dspType === eXpress.services.DSPType.ListDSP ? product.designVariantInListDSP : product.designVariantInOpenDSP;
			let result = false;

			// Hide
			if (designVariantInDSP === eXpress.services.InDsp.Hide)
				return result;

			// DropDown
			if (designVariantInDSP === eXpress.services.InDsp.Dropdown) {
				if (design.alternativeColors && design.alternativeColors.length > 1) {
					const altColorsWithDesignVariants = design.alternativeColors.filter(ac => ac.designVariant);
					const designVariantNames = altColorsWithDesignVariants
						.filter(ac => ac.designVariant!.designVariantName)
						.map(ac => ac.designVariant!.designVariantName.toLowerCase());
					const data: IDropDownData[] = altColorsWithDesignVariants
						.map(ac => (
							{
								productCode: ac.productCode.toLowerCase(),
								predefinedProductName: ac.predefinedProductName.toLowerCase()
							}
						));

					if (data.length === 0 || designVariantNames.length === 0)
						return false;

					// get designvariantname for chosen pdp
					const pdp = altColorsWithDesignVariants.filter(ac => ac.predefinedProductName.toLowerCase() === design.predefinedProductName.toLowerCase());
					const topText = pdp[0].designVariant!.designVariantName;

					const $dropDown = this.createOpenDspDropDown($original, designVariantNames, "designvariants", data, topText);
					if ($dropDown) {
						$dropDown.insertBefore($itemToInsertBefore);
					}

					result = true;
					return result;
				}
			}

			// Icons / Colors
			if (design.alternativeColors && design.alternativeColors.length > 1) {
				result = true;
				for (let j = 0; j < design.alternativeColors.length; j++) {
					// if designVariant -> is an icon
					const des = design.alternativeColors[j].designVariant;
					let designVariantIcon: eXpress.services.IIcon | undefined;

					if (des)
						designVariantIcon = {
							IconSvg: des.icon,
							IconColorCode: des.iconColorCode,
							IconOverLayColorCode: null,
							Label: des.designVariantName,
							Orientation: null
						};

					const $template = $iconTemplate.clone();
					const $icon = this.createIcon($template, designVariantInDSP, dspType, designVariantIcon, design.alternativeColors[j].color);
					if ($icon) {
						$icon.attr('data-predefinedproductname', design.alternativeColors[j].predefinedProductName.toLowerCase());
						$icon.attr('data-productcode', design.alternativeColors[j].productCode.toLowerCase());
						if (design.predefinedProductName.toLowerCase() === design.alternativeColors[j].predefinedProductName.toLowerCase())
							$icon.addClass('active');
						$colorList.append($icon);
					}
					else {
						return false;
					}
				}

				if ($itemToInsertBefore.length !== 0)
					$colorList.insertBefore($itemToInsertBefore);
				else
					$original.find(container).append($colorList);
			}

			return result;
		}

		private arrayEquals(a, b) {
			return Array.isArray(a) &&
			Array.isArray(b) &&
			a.length === b.length &&
			a.every((val, index) => val === b[index]);
		}

		private createTileProductAlternatives($original: JQuery, design: core.IDesign, container: string, dspType: eXpress.services.DSPType): boolean {

			//Template
			const $altList = $original.find('.item-icons-right');
			const $altTemplate = $altList.find('.a-icon').detach();
			const $itemToInsertBefore = $altList.next();
			$altList.detach();
			$altList.empty();

			let result = false;

			if (design.productAlternativesGroups && design.productAlternativesGroups.length > 0) {
				const group = design.productAlternativesGroups[0];

				const productAlternativeInDsp: eXpress.services.InDsp = dspType === eXpress.services.DSPType.ListDSP ? group.inListDSP : group.inOpenDsp;
				// Hide
				if (productAlternativeInDsp === eXpress.services.InDsp.Hide)
					return result;

				// DropDown
				if (productAlternativeInDsp === eXpress.services.InDsp.Dropdown) {
					// get alternativeName based on value
					const productAlternatives = group.productAlternatives.filter(pa => pa);
					if (productAlternatives.length > 1) {
						const productAlternativeTitles = productAlternatives.map(p => p.title);
						const data: IDropDownData[] = productAlternatives.map(p => {
							return { productCode: p.productCode.toLowerCase(), predefinedProductName: p.predefinedProductName.toLowerCase() };
						});

						// get title for chosen pdp
						const pdp = productAlternatives.filter(pa => pa.predefinedProductName.toLowerCase() === design.predefinedProductName.toLowerCase());
						const topText = pdp[0].title;

						const $dropDown = this.createOpenDspDropDown($original, productAlternativeTitles, "product-alternatives", data, topText);
						if ($dropDown) {
							$dropDown.insertBefore($itemToInsertBefore);
						}

						result = true;
						return result;
					}
				}

				// Icons
				if (group.productAlternatives && group.productAlternatives.length > 1) {
					result = true;

					const fromCache = this.previousProductGroupAlternatives &&
						this.previousProductGroupAlternatives.length &&
						this.arrayEquals(this.previousProductGroupAlternatives.map(m => m.predefinedProductName), this.activeProductGroupAlternatives.map(m => m.predefinedProductName));

					if (fromCache) {
						const groupProductAlternatives = group.productAlternatives.filter(f => this.activeProductGroupAlternatives.map(m => m.productVariantCode).indexOf(f.productVariantCode) > -1);

						this.drawIcons(productAlternativeInDsp, dspType, design, groupProductAlternatives, $altTemplate, $altList);

						if ($itemToInsertBefore.length)
							$altList.insertBefore($itemToInsertBefore);
						else
							$original.find(container).append($altList);
					}
					else
					{
						this.drawIconsAsync(productAlternativeInDsp, dspType, design, group.productAlternatives, $altTemplate, $altList).then(icons => {
							this.previousProductGroupAlternatives = this.activeProductGroupAlternatives;

							if ($itemToInsertBefore.length)
								icons.insertBefore($itemToInsertBefore);
							else
								$original.find(container).append(icons);
						});
					}
				}
			}

			return result;
		}

		private insertChildAtPosition(parent: HTMLElement, child: HTMLElement, index: number) {
			if (!index) index = 0;
			if (index >= parent.childNodes.length)
				parent.appendChild(child);
			else
				parent.insertBefore(child, parent.childNodes[index]);
		}

		private drawIcons(productAlternativeInDsp: eXpress.services.InDsp, dspType: eXpress.services.DSPType, design: core.IDesign, productAlternatives: core.IProductAlternative[], $altTemplate: JQuery<HTMLElement>, $altList: JQuery<HTMLElement>) {
			for (let k = 0; k < productAlternatives.length; k++) {
				const alt = productAlternatives[k];
				if (!alt) continue;
				const $catNew = $altTemplate.clone();

				const iconData = {
					IconSvg: alt.icon,
					IconColorCode: alt.iconColorCode,
					IconOverLayColorCode: alt.iconOverlayColorCode,
					Label: alt.title,
					Orientation: alt.orientation
				};

				if (alt.predefinedProductName) {
					const $icon = this.createIcon($catNew, productAlternativeInDsp, dspType, iconData);

					if ($icon) {
						$icon.attr('data-predefinedproductname', alt.predefinedProductName.toLowerCase());
						$icon.attr('data-productcode', alt.productCode.toLowerCase());
						$icon.attr('title', alt.title);

						if (design.pvc.toLowerCase() === alt.productVariantCode.toLowerCase())
							$catNew.addClass('active');

						$altList.append($catNew);
					}
				}
			}

			return $altList;
		}

		private async drawIconsAsync(productAlternativeInDsp: eXpress.services.InDsp, dspType: eXpress.services.DSPType, design: core.IDesign, productAlternatives: core.IProductAlternative[], $altTemplate: JQuery<HTMLElement>, $altList: JQuery<HTMLElement>) {
			const promises: JQueryPromise<JQuery<HTMLElement>>[] = [];

			for (let k = 0; k < productAlternatives.length; k++) {
				const alt = productAlternatives[k];
				if (!alt) continue;
				const $catNew = $altTemplate.clone();

				const iconData = {
					IconSvg: alt.icon,
					IconColorCode: alt.iconColorCode,
					IconOverLayColorCode: alt.iconOverlayColorCode,
					Label: alt.title,
					Orientation: alt.orientation
				};

				if (alt.predefinedProductName) {
					const promise = $.Deferred();
					promise.resolve(this.GetOrLoadDesignAsync(alt.predefinedProductName.toLowerCase(), alt.productCode.toLowerCase())
						.then(alternativeDesign => {
							this.activeProductGroupAlternatives.push(alt);
							const $icon = this.createIcon($catNew, productAlternativeInDsp, dspType, iconData);

							if ($icon && alternativeDesign) {
								$icon.attr('data-predefinedproductname', alt.predefinedProductName.toLowerCase());
								$icon.attr('data-productcode', alt.productCode.toLowerCase());
								$icon.attr('title', alt.title);

								if (design.pvc.toLowerCase() === alt.productVariantCode.toLowerCase())
									$catNew.addClass('active');

								this.insertChildAtPosition($altList[0], $catNew[0], k);

								return $altList;
							}
						}));

					promises.push(promise);
				}
			}

			return $.when.apply(undefined, promises).promise();
        }

		private createTileConstellations($original: JQuery, design: core.IDesign, constellations: core.IConstellation[], container: string): boolean {
			let result = false;
			const $list = $original.find('.item-constellations');
			const $itemToInsertBefore = $list.next();
			$list.detach();
			const $template = $list.find('span').first().detach();
			$list.empty();
			if (constellations && constellations.length > 1) {
				result = true;
				for (let k = 0; k < constellations.length; k++) {
					const $new = $template.clone();
					$new.attr('data-predefinedproductname', design.predefinedProductName.toLowerCase());
					$new.attr('data-productcode', constellations[k].productCode.toLowerCase());
					$new.attr('title', constellations[k].productName);
					$new.find('span.label').html(constellations[k].shortName);
					if (design.productCode.toLowerCase() === constellations[k].productCode.toLowerCase())
						$new.addClass('active');
					$new.addClass('productcode-' + eXpress.utils.makeCssClass(constellations[k].productCode));
					$list.append($new);
				}
				if ($itemToInsertBefore.length !== 0)
					$list.insertBefore($itemToInsertBefore);
				else
					$original.find(container).append($list);
			}
			return result;
		}

		private createTileOptions($original: JQuery, productOptionGroups: core.IDesignProductOptionGroup[] | undefined, container: string, defaultDspOverlay: string, defaultOpenDspOverlay: string): boolean {
			let result = false;
			const $optionList = $original.find('.item-options');
			$optionList.detach();
			const $itemToInsertBefore = $optionList.next();
			const $optionTemplate = $optionList.find('span').first().detach();
			$optionList.empty();
			if (productOptionGroups && productOptionGroups.length > 0) {
				for (let l = 0; l < productOptionGroups.length; l++) {
					// We have a list of OptionGroups we loop them all and take the first that has flag OptionInDsp.Icons
					const optionGroup = productOptionGroups[l];
					if (optionGroup.inDsp === eXpress.services.OptionInDsp.Icons) {
						if (optionGroup && optionGroup.productOptions && optionGroup.productOptions.length > 0) {
							result = true;

							// Add the sibling data
							$optionList.attr('optiongroup', optionGroup.code.toLowerCase());
							$optionList.attr('siblingdatapagetitle', optionGroup.siblingDataPageTitle || "");
							$optionList.attr('siblingoptionusps', optionGroup.siblingDataOptionUSPs);

							let $optionNew: JQuery | null = null;
							const standardoptionNames = [] as string[];

							for (let m = 0; m < optionGroup.productOptions.length; m++) {
								const option = optionGroup.productOptions[m];
								$optionNew = $optionTemplate.clone();
								$optionNew.attr('data-optioncode', option.code);
								$optionNew.attr('data-alternativeoptiongroup', option.alternativeOptionGroup);
								$optionNew.attr('data-optionname', option.name);
								$optionNew.attr('data-optiondspoverlay', option.dspOverlayUrl || "");
								$optionNew.attr('data-optionopendspoverlay', option.openDspOverlayUrl || "");
								$optionNew.attr('title', option.name);
								$optionNew.attr('data-optionprice', option.price);
								$optionNew.addClass('option-' + eXpress.utils.makeCssClass(option.code));
								standardoptionNames.push(eXpress.utils.makeCssClass(option.code));
								if (this.currentOption1 && this.currentOption1.code.toLowerCase() === option.code.toLowerCase()) {
									$optionNew.addClass('active');
									this.setSiblingData($original.closest('article'), $optionNew, $optionList, this.currentOption1);
								}
								$optionList.append($optionNew);
							}

							// We add the default icon (no option) and select it
							$optionNew = $optionTemplate.clone();
							$optionNew.attr('data-optioncode', '');
							$optionNew.attr('data-alternativeoptiongroup', "");
							$optionNew.attr('data-optiondspoverlay', defaultDspOverlay);
							$optionNew.attr('data-optionopendspoverlay', defaultOpenDspOverlay);
							let standardOptionName = 'option-standard';
							standardoptionNames.sort().reverse();
							standardOptionName += "-" + standardoptionNames.join("-");
							$optionNew.addClass(standardOptionName);
							if (!this.currentOption1)
								$optionNew.addClass('active');
							$optionList.prepend($optionNew);
						}
						break;
					}
				}
				if ($itemToInsertBefore.length !== 0)
					$optionList.insertBefore($itemToInsertBefore);
				else
					$original.find(container).append($optionList);
			}
			return result;
		}

		private createTile(design: core.IDesign, $new: JQuery, lazy: boolean, dspType: eXpress.services.DSPType): JQuery {
			if (design.debug)
				$new.prepend("<div style='position: absolute; top: 0; left: 0;z-index: 10;margin:5px; padding: 2px; width: calc(100% - 10px); background: rgb(244,192,141, 0.4);'>" + design.debug.replace(/\r\n/g, '<br />') + "</div>");

			// Fill in the attributes to use later on
			$new.attr('data-productcode', design.productCode.toLowerCase());
			$new.attr('data-predefinedproductname', design.predefinedProductName.toLowerCase());
			$new.attr('data-productname', design.product.name.toLowerCase());
			$new.attr('data-pvc', design.pvc);
			$new.attr('data-categorylist', design.productCategoryGroups.join('/'));
			if (this.crossSellFrom)
				$new.attr('data-crossSellFrom', this.crossSellFrom);

			// Fill in the simple data
			$new.find('.item-title').html(design.dspName);
			const $newImage = $new.find('img.lazy');
			const $filler = $new.find('item-title');
			const fullUrl = design.packshotUrl + "?" + this.context.productRevision;
			$newImage.attr('data-original', fullUrl);
			$newImage.attr('alt', design.dspName);
			if (!lazy) {
				$newImage.attr('src', fullUrl);
				$new.removeClass('loading');
				$newImage.parent().removeAttr("style");
				$filler.removeClass('u-hide');
			}
			$new.find('.price').html(design.displayPrice);
			$new.find('.price-per-unit').html(design.displayPricePerUnit);
			if (!design.showStar)
				$new.find('.as-from').remove();

			if (design.temporaryUnavailable) {
				$new.find('.eyecatcher').addClass("eyecatcher--temporarily-unavailable");
				$new.addClass('disabled');
				$new.find('.eyecatcher .tu').show();
				$new.find('.eyecatcher').show();
			}
			else if (design.top) {
				$new.find('.eyecatcher .top').show();
				$new.find('.eyecatcher').show();
			}
			else if (design.new) {
				$new.find('.eyecatcher .new').show();
				$new.find('.eyecatcher').show();
			}

			// Fill in the alternative colors
			this.createTileAlternativeColors($new, design, '.header', dspType);

			// Fill in the alternative categories
			this.createTileProductAlternatives($new, design, '.header', dspType);

			// set visualisation if changeable background
			this.setDesignActivedForBackGround($new, design, '.header', dspType);

			// Adorner ?
			const $adorner = $new.find('.adorner-container img');
			this.showAdorner($adorner, design.dspOverlayUrl);

			return $new;
		}

		private setDesignActivedForBackGround($template: JQuery, design: core.IDesign, selector: string, dspType: services.DSPType): boolean {

			// header container to attach to;
			const $header = $template.find(selector);
			const iconsContainerSelector = dspType === eXpress.services.DSPType.ListDSP ? ".item-icons-center" : ".m-icon-with-text";
			const $iconsContainer = $template.find(iconsContainerSelector);
			const icon = this.contentManager.getIconByKey("paintbrush");

			if (design.canSwitchBackgroundInCreator && icon) {

				//label
				const label = this.contentManager.getLabel (
					dspType === eXpress.services.DSPType.ListDSP
						? "Label.DspMulti.ChangeBackground.ListDSP"
						: "Label.DspMulti.ChangeBackground.OpenDSP"
					, dspType === eXpress.services.DSPType.ListDSP
						? "Multicolour"
						: "Choose your favourite backgroundcolour in the following step"
				);

				if (dspType === eXpress.services.DSPType.ListDSP) {

					const $iconSpan = $iconsContainer.find('.a-icon').detach();
					const $iconSymbol = $iconSpan.find('.a-icon__symbol');
					$iconSpan.attr('data-predefinedproductname', design.predefinedProductName.toLowerCase());
					$iconSpan.attr('data-productname', design.product.name.toLowerCase());
					$iconSymbol.html(icon);

					$iconsContainer.detach();
					$iconsContainer.empty();
					$iconSpan.attr('title', label);
					$iconsContainer.append($iconSpan);
					$header.append($iconsContainer);
				} else if (dspType === eXpress.services.DSPType.OpenDSP) {
					html.show($iconsContainer.get(0));
					$iconsContainer.find('.a-icon__symbol').html(icon);
					$iconsContainer.find('.m-icon-with-text__text').html(label);
					$iconsContainer.find('.a-icon').attr('data-predefinedproductname', design.predefinedProductName.toLowerCase());
					$iconsContainer.find('.a-icon').attr('data-productname', design.product.name.toLowerCase());

					const $cloneContainer = $iconsContainer.clone();

					const $namecontainer = $template.parent().find('.productcategory-name-container');
					if ($namecontainer.find(".m-icon-with-text").length < 1)
						$namecontainer.append($cloneContainer);
					else
						$namecontainer.find(".m-icon-with-text").replaceWith($cloneContainer);
				}
			} else {

				html.hide($iconsContainer.get(0));
				const $namecontainer = $template.parent().find('.productcategory-name-container');
				if ($namecontainer.find(".m-icon-with-text").length > 0)
					$namecontainer.find(".m-icon-with-text").remove();

				return false;
			}

			return true;
		}

		private setExtraLabelOnDetail(detailEl: HTMLElement, design: core.IDesign) {
			const itemLabelEl = html.querySelector<HTMLElement>(detailEl, ".item-label", true);
			if (design.supportsPersonalData) {
				core.showLoadingDialogAsync(this.contentManager.getLabelAsync("Label.DspMulti.PersonalEventsAvailable")
					.always(label => {
						itemLabelEl.innerHTML = label || "Design with personal events";
						html.addClass(itemLabelEl, "item-label--is-visible");
						utils.reduceFontsizeToFit(itemLabelEl, 11);
					}));
			} else {
				html.removeClass(itemLabelEl, "item-label--is-visible");
			}
		}

		private addItems(designKeys: string[], showCurrentDetail: boolean) {
			const maxPages = Math.ceil(this.totalDesignCount / this.pageSize);
			if (this.pageNumber >= maxPages)
				$('.dsp-item-list-footer button.main').hide();
			else {
				$('.dsp-item-list-footer button.main').show();
				$('.dsp-item-list-footer button.main').removeClass('loading');
			}

			$('.dsp-content-top p.multiple').hide();
			$('.dsp-content-top p.one').hide();
			$('.dsp-content-top p.zero').hide();

			if (this.totalDesignCount > 0) {
				if (this.totalDesignCount > 1) {
					$('.dsp-content-top p.multiple').show();
				}
				else {
					$('.dsp-content-top p.one').show();
				}

				$('span.filter-info').each((indx, el) => {
					$(el).html("");
				});

				$('.tag-active').each((indx, el) => {
					let filter = el.getAttribute('data-sp-selectcategory');
					const item = el.getAttribute('data-sp-selecttag') || '';
					let result = "";
					if (filter && typeof filter !== 'undefined') {
						filter = filter.toLowerCase();
						if (filter === 'imagecount' || filter === 'price') {
							result = $(".cat-" + filter.replace(".", "-") + " span.value").html();
						}
						else {
							result = $('.filter-' + filter.replace(".", "-") + ' .selectBox span.filter-info').html();
							result = result.concat($('label[data-sp-filter-tag= "' + item + '"]').attr('data-sp-filter-translated') || '').concat(", ");
						}
						$('.filter-' + filter + ' .selectBox span.filter-info').html(result);
					}
				});

				$('span.filter-info').each((indx, el) => {
					const $filter = $(el).parent().parent();
					const filter = $($filter).attr('data-sp-selectcategory');
					let result = $(el).html();
					if (filter !== 'imageCount' && filter !== 'price') {
						const checkLength = 50;
						if (result.length > checkLength)
							result = result.substring(0, checkLength).concat("...");
						else {
							result = result.substring(0, result.length - 2);
						}
					}
					$(el).html(result);
				});

				const totalCount = utils.formatString(this.contentManager.getLabel("Label.DesignSelection.FilterAmount", "Show {0} results"), this.totalDesignCount.toString());
				$('.dsp-result-bottom span').html(totalCount);
				$('.dsp-content-top .info span').html(this.totalDesignCount.toString());
				const $dspItemList = $('.dsp-content .dsp-item-list');
				const $itemToInsertBefore = $dspItemList.next();
				$dspItemList.detach();
				const $template = $('.template-container .item');

				for (let i = 0; i < designKeys.length; i++) {
					const pdp = designKeys[i];
					const $new = $template.clone();
					if (pdp) {
						$dspItemList.append (
							this.createTile (
								this.designs[pdp],
								$new,
								true,
								eXpress.services.DSPType.ListDSP
							)
						);
					}
				}

				$dspItemList.insertBefore($itemToInsertBefore);

				this.repositionDetail();

				$("img.lazy").lazyload({
					threshold: 200,
					load: function () {
						$(this).closest('.loading').removeClass('loading');
						$(this).parent().removeAttr("style");
						$(this).closest('.item-container').find('.item-filler').removeClass('u-hide');
					}
				});

				if (showCurrentDetail)
					this.showCurrentDetail();
			}
			else {
				$('.dsp-content-top p.zero').show();
				$('.dsp-content .dsp-item-list').append($('.no-designs-found').clone());
			}

			if (this.productHasQuantityBreakOnlyInMa && this.productCode.length > 0) {
				this.remark.html(this.pageContext.labelStartingAt);
			}

			window.HideLoadingDialog();
		}

		private toggleFilters(toggle = false) {
			this.filterToggle.toggleClass("open", toggle);
			this.filterChoice.toggleClass("open", toggle);
			$(".filter-container").toggleClass("open", toggle);

			$(".main.small.filter-toggle").prop('disabled', toggle);
		}

		private removeFilters() {
			window.ShowLoadingDialog();
			this.occasion = '';
			this.purpose = '';
			this.productCode = [];
			this.orientation = '';
			this.predefinedProductCategory = [];
			this.searchColor = [];
			this.imageCount = [];
			this.price = [];
			this.gender = '';
			this.clear();
			this.fetchPageAndRenderAsync(1, true);
			$('.filter-selection').removeClass('visible');
			$(".selectBox").removeClass("hasItemsSelected");
			this.remark.removeClass('remark-right');

			this.currentProductCode = undefined;
			this.currentPredefinedProductName = undefined;
			this.setHistoryUrl();
		}

		public changeFilter(filterName: string, filterValue: string[]);
		public changeFilter(filterName: string, filterValue: string);
		public changeFilter(filterName: string, filterValue: number[]);
		public changeFilter(filterName: string, filterValue: number);
		public changeFilter(filterName: string, filterValue: any) {
			window.ShowLoadingDialog();
			if ($.isArray(this[filterName])) {
				this[filterName] = filterValue;
			}
			else {
				if ($.isArray(filterValue)) {
					if (filterValue.length > 0)
						this[filterName] = filterValue[0];
					else
						this[filterName] = null;
				}
				else {
					this[filterName] = filterValue;
				}
			}
			this.syncFilter(filterName, filterValue);
			this.clear();
			this.fetchPageAndRenderAsync(1, true);
			this.currentProductCode = undefined;
			this.currentPredefinedProductName = undefined;
			this.setHistoryUrl();
		}

		private changeSorting(filterValue: string) {
			window.ShowLoadingDialog();
			this.sortMethod = filterValue;
			this.clear();
			this.fetchPageAndRenderAsync(1, true);
			this.currentProductCode = undefined;
			this.currentPredefinedProductName = undefined;
			this.setHistoryUrl();
		}

		private hideAndShowForOwnDesign() {
			if (this.ownDesign)
				$('.tag-filter').addClass('own-designs');
			else
				$('.tag-filter').removeClass('own-designs');
		}

		private toggleOwnDesign() {
			window.ShowLoadingDialog();
			this.ownDesign = !this.ownDesign;
			this.clear();

			this.hideAndShowForOwnDesign();
			if (this.ownDesign) {
				this.fetchPageAndRenderAsync(1, false);
			}
			else {
				this.fetchPageAndRenderAsync(1, true);
			}
			this.currentProductCode = undefined;
			this.currentPredefinedProductName = undefined;
			this.setHistoryUrl();
		}

		private syncFilter(filterName: string, filterValue: any) {
			// Fetch all existing tags for the filter & remove them
			const $allTags = $('.filter-selection-tags .tag-active[data-sp-selectcategory="' + filterName + '"]');
			$allTags.remove();

			// Add the tags
			if ($.isArray(filterValue)) {
				// hack for sliders, only add 1 tag instead of 2 !
				if (filterName === 'imageCount' || filterName === 'price') {
					if (filterValue.length > 0)
						this.addTag(filterName, 'slider');
				}
				else {
					$.each(filterValue, (index, value) => {
						this.addTag(filterName, value);
					});
				}
			}
			else {
				if (filterValue !== '')
					this.addTag(filterName, filterValue);
			}

			const $selection = $('.filter-selection');
			if ($selection.find('.tag-active').not('.tag-delete-all-designs').length > 1) {
				if (!$selection.hasClass('visible')) {
					$selection.addClass('visible');
					this.remark.addClass('remark-right');
				}
			}
			else {
				$selection.removeClass('visible');
				this.remark.removeClass('remark-right');
			}
		}

		private addTag(filterName: string, filterValue: string) {
			let translated = '';
			// Special case for price and imagecount
			if (filterName === 'price') {
				translated = utils.displayPrice(this.price[0], true, false, this.pageContext) + ' - ' + utils.displayPrice(this.price[1], true, false, this.pageContext);
			}
			else if (filterName === 'imageCount') {
				translated = this.imageCount[0] + ' - ' + this.imageCount[1];
			}
			else {
				// Fetch the translated value
				const $label = $('.filter-choice .multiselect[data-sp-selectcategory="' + filterName + '"] .checkboxes label[data-sp-filter-tag="' + filterValue + '"]');
				translated = $label.attr('data-sp-filter-translated') || '';
			}

			const $new = $(".filter-selection-tags .tag-active.empty").clone();
			$new.removeClass("empty").addClass("cat-" + eXpress.utils.makeCssClass(filterName)).attr("data-sp-selecttag", filterValue).attr("data-sp-selectcategory", filterName);
			const $value = $new.find('.value');
			if (filterName.toLowerCase() === 'searchcolor') {
				$value.css('background-color', filterValue);
				$new.addClass('searchcolor-' + eXpress.utils.makeCssClass(filterValue));
			}
			$value.html(translated);

			$new.insertAfter(".filter-selection-tags .tag-active.empty").show();
		}

		private changeTileClicked($tile: JQuery, predefinedProductName: string, productCode: string) {
			const timeout = window.setTimeout(function () {
				$tile.addClass('loading');
			}, 300);

			this.GetOrLoadDesignAsync(predefinedProductName, productCode).then(design => {
				this.changeTile(design, $tile);
			}).always(() => {
				window.clearTimeout(timeout);
				$tile.removeClass('loading');
			});
		}

		private changeTile(design: core.IDesign, $tile: JQuery) {
			const $template = $('.template-container .item');
			const $new = $template.clone();

			// Show filler
			$new.find('.item-filler').removeClass('u-hide');

			const $newTile = this.createTile(design, $new, false, eXpress.services.DSPType.ListDSP);
			$tile.replaceWith($newTile);
		}

		private showDetailClick($item: JQuery, keepData: boolean, loadQuantitiesFromURL = false) {
			const predefinedProductname = $item.attr('data-predefinedproductname') || "";
			const productCode = $item.attr('data-productcode') || "";
			const productName = $item.attr('data-productname') || "";
			const pvc = $item.attr('data-pvc');
			const categoryList = $item.attr('data-categorylist');
			this.currentCategoryList = categoryList;

			if (window.dataLayer[0].datalayerversion < '2022-06') {
				const gtmData = {
					'eventCategory': 'Design Selection',
					'eventAction': productName, // product name
					'eventLabel': predefinedProductname, // design name
					'eventProduct': productCode, // product ID
					'event': 'designSelection',
					'ecommerce': {
						'detail': {
							products: [
								{
									'id': productCode,
									'variant': pvc,
									'name': productName,
									'category': categoryList
								}
							]
						}
					}
				};

				// Push google GTM data
				const dataLayer = window.dataLayer || [];
				dataLayer.push(gtmData);

				const iframe = $('#dataLayerIframe')[0] as HTMLIFrameElement;
				if (iframe && iframe.contentWindow && iframe.contentWindow.pushDataLayer)
					iframe.contentWindow.pushDataLayer(gtmData);
			}

			// WEB-5324: Hide constellations on open DSP
			// const constellationPromise = this.getOrLoadConstellations(productCode, predefinedProductname);

			const designPromise = this.GetOrLoadDesignAsync(predefinedProductname, productCode)
				.then(design => {
					return this.services.selectionPage.getDesignDetail(this.context.pointOfSaleId,
						this.context.languageCode,
						predefinedProductname,
						productCode,
						this.ownDesign ? undefined : this.occasion,
						this.ownDesign ? undefined : this.purpose,
						this.theme,
						this.options
					)
						.then(designDetail => { return { designDetail, design }; });
				});

			// WEB-5324: Hide constellations on open DSP
			core.showLoadingDialogAsync(designPromise)
				.then((res) => this.showDetail(res.designDetail, res.design, $item, keepData, loadQuantitiesFromURL));
		}

		private hideDetailClick(animate: boolean, scrollTo = true) {
			this.currentProductCode = undefined;
			this.currentPredefinedProductName = undefined;
			this.setHistoryUrl();

			const $detail = $('.item-detail.visible');
			if ($detail.length > 0) {
				let compensateHeight = 0;
				if ($detail.offset()!.top < $(window).scrollTop()!)
					compensateHeight = $detail.outerHeight()! + 12; // Why -12 ? There is an extra arrow, 12px in space added inbetween the detail and the clicked tile
				$detail.removeClass('visible');
				const $active = $('.item.active');
				$active.removeClass('active');
				if (animate)
					$('html,body').animate({ scrollTop: $active.offset()!.top - eXpress.utils.getHeaderHeight() }, 'slow');
				else if (scrollTo)
					$('html,body').scrollTop($(window).scrollTop()! - compensateHeight);
			}
		}

		private performUpdatePriceDetail($priceTag: any, $priceDetailList: any, priceDetails: core.IPriceDetails) {
			// Update the actual price
			$priceTag.html(utils.displayPrice(priceDetails.price.amount, true, false, this.pageContext));

			// Update the detailed table below the price
			const $container = $priceDetailList.find('.bottom-center').detach();
			const $template = $container.find('.tooltip').first();
			$container.empty();

			for (let i = 0; i < priceDetails.priceItems.length; i++) {
				const $new = $template.clone();
				$new.find('.price-detail-description').html(priceDetails.priceItems[i].description);
				$new.find('.price-detail-calculation').html(priceDetails.priceItems[i].calculationDescription);
				$new.find('.price-detail-result').html(priceDetails.priceItems[i].itemTotal);
				$container.append($new);
			}

			$priceDetailList.append($container);
		}

		private updatePriceDetail($priceTag: JQuery, $priceDetailList: JQuery) {
			const quantity = this.currentQuantities.reduce((a, c) => a + c.quantity, 0);
			const options = [] as string[];
			if (this.currentOption1 && this.currentOption1.code)
				options.push(this.currentOption1.code);
			if (this.currentOption2 && this.currentOption2.code)
				options.push(this.currentOption2.code);
			this.orderService.getPriceAsync(
				this.currentPvc,
				quantity,
				0,
				options,
				this.pageContext.promoCode)
				.then(res => this.performUpdatePriceDetail($priceTag, $priceDetailList, res));
		}

		private setSiblingData($detail, $item, $parent, option: CurrentOption | undefined) {
			const shouldSetSiblingData = ($parent.attr('optiongroup') === this.optionGroup);
			if (shouldSetSiblingData) {
				if (option) {
					if ($parent.attr('siblingdatapagetitle'))
						$detail.find('h2.productcategory-name').html($parent.attr('siblingdatapagetitle'));
					if ($parent.attr('siblingoptionusps'))
						$detail.find('.usps').html($parent.attr('siblingoptionusps'));

					// Change breaks to price + options price
					const $breakList = $detail.find('.item-pricing table tbody tr td.price');
					$breakList.each((i, b) => {
						const $break = $(b);
						$break.html(utils.displayPrice(parseFloat($break.attr('data-price')!) + option.price, true, false, this.pageContext));
					});

				}
				else {
					const $h2 = $detail.find('h2.productcategory-name');
					$h2.html($h2.attr('original'));
					const $usps = $detail.find('.usps');
					$usps.html($usps.attr('original'));

					// Reset the breaks to the original price
					const $breakList = $detail.find('.item-pricing table tbody tr td.price');
					$breakList.each((i, b) => {
						const $break = $(b);
						$break.html(utils.displayPrice(parseFloat($break.attr('data-price')!), true, false, this.pageContext));
					});
				}
			}
		}

		private changeOptions($item: any) {
			const $detail = $('.item-detail');
			const $parent = $item.parent();

			const optionCode = $item.attr('data-optioncode');
			if (optionCode) {
				this.currentOption1 = new CurrentOption();
				this.currentOption1.code = optionCode.toLowerCase();
			}
			else
				this.currentOption1 = undefined;

			// Remove all existing option classes
			const classList = $detail.attr('class')!.split(/\s+/);
			$.each(classList, function (index, item) {
				if (item.lastIndexOf('option', 0) === 0)
					$detail.removeClass(item);
			});
			if (this.currentOption1) {
				$detail.addClass('option-' + eXpress.utils.makeCssClass(this.currentOption1.code));
				this.currentOption1.price = parseFloat($item.attr('data-optionprice'));
				this.currentOption1.name = $item.attr('data-optionname');
				this.currentOption1.alternativeOptionGroup = $item.attr('data-alternativeoptiongroup');
				this.currentOption1.optionGroup = $item.parent().attr('optiongroup');
			}

			// Set sibling data
			this.setSiblingData($detail, $item, $parent, this.currentOption1);

			// Add the adorner
			const $adorner = $detail.find('.adorner-container img');
			this.showAdorner($adorner, $item.attr('data-optionopendspoverlay'));

			// Set the correct editorstart URL
			const $next = $detail.find('.dsp-next');
			const allOptions = [this.currentOption1, this.currentOption2]
				.filter(function (val) { return (val && val.code); })
				.map(v => v!.code).join(',');

			const nextUrl = utils.updateParameter("options", allOptions, $next.attr('href'));
			$next.attr('href', nextUrl);


			// Set ourselves to active
			$('.item-options span').removeClass('active');
			$item.addClass('active');

			this.updatePriceDetail($detail.find('.price-tag'), $detail.find('.price-detail-list'));
		}

		private changeDspAttribute($item: any) {
			this.currentAttribute = $item.attr('data-attributecode');
			const labelText = $item.html();
			$('.item-detail .item-detail-content-header .item-attributes .selectBox label').html(labelText);

			const $list = $item.closest('.multiselect').children('.checkboxes');
			$list.toggle();
			const $label = $item.closest('.multiselect').children('.selectBox');
			$label.toggleClass("open");

			if (this.currentAttribute && this.currentProductCode) {
				const $next = $('.item-detail .dsp-next');
				const nextUrl = utils.updateParameter('pvc', this.currentProductCode.toLowerCase() + '_' + this.currentAttribute.toLowerCase(), $next.attr('href'));
				$next.attr('href', nextUrl);
			}
		}

		private changeDspOptions($item: any) {
			const optionCode = $item.attr('data-optioncode');
			if (optionCode) {
				this.currentOption2 = new CurrentOption();
				this.currentOption2.code = optionCode.toLowerCase();
			}
			else
				this.currentOption2 = undefined;

			const labelText = $item.html();
			$('.item-detail .item-detail-content-header .item-options .selectBox label').html(labelText);

			const $list = $item.closest('.multiselect').children('.checkboxes');
			const $label = $item.closest('.multiselect').children('.selectBox');

			// Remove all other checked classes
			$list.find('label').removeClass('checked');
			// Set the item to checked
			$item.addClass('checked');
			// Close the dropdown
			$list.toggle();
			$label.toggleClass("open");

			if (this.currentOption2) {
				this.currentOption2.price = parseFloat($item.attr('data-optionprice'));
				this.currentOption2.name = $item.attr('data-optionname');
				this.currentOption2.alternativeOptionGroup = $item.attr('data-alternativeoptiongroup');
				this.currentOption2.optionGroup = $item.parent().attr('optiongroup');
			}
			// Set sibling data
			this.setSiblingData($item.closest('article'), $item, $item.closest('.item-options'), this.currentOption2);

			this.updatePriceDetail($('.item-detail').find('.price-tag'), $('.item-detail').find('.price-detail-list'));

			// Set the correct editorstart URL
			const $next = $('.item-detail .dsp-next');
			const allOptions = [this.currentOption1, this.currentOption2].filter(function (val) { return (val && val.code); }).map(v => v!.code).join(',');
			const nextUrl = utils.updateParameter('options', allOptions, $next.attr('href'));
			$next.attr('href', nextUrl);

		}

		private changeQuantity($item: any, multi: boolean) {
			const quantity = parseInt($item.val(), 10) || (multi ? 0 : 1);
			let attr = null;
			if (multi)
				attr = $item.closest('.item-attributes').attr('data-attributecode')!;
			this.performChangeQuantity(attr, quantity);
		}

		private changeQuantityPlusMin($item: any) {
			const $input = $item.parent().children('input');
			let quantity = parseInt($input.val(), 10) || 0;
			const attr = $item.closest('.item-attributes').attr('data-attributecode');

			if ($item.hasClass('counter-plus'))
				quantity++;
			else {
				quantity = (quantity > 0) ? --quantity : 0;
			}
			this.performChangeQuantity(attr, quantity);
			$input.val(quantity.toString());
		}

		private performChangeQuantity(attr: string | null, quantity: number) {
			let found = false;
			let total = 0;
			let indexToRemove = -1;
			for (let i = 0; i < this.currentQuantities.length; i++) {
				if (this.currentQuantities[i].attribute === attr) {
					found = true;
					if (quantity && quantity > 0) {
						this.currentQuantities[i].quantity = quantity;
						total += this.currentQuantities[i].quantity;
					}
					else
						indexToRemove = i;
				}
				else
					total += this.currentQuantities[i].quantity;
			}
			if (!found && quantity && quantity > 0) {
				const newQuantity = new Quantity(attr, quantity);
				this.currentQuantities.push(newQuantity);
				total += quantity;
			}
			if (indexToRemove >= 0)
				this.currentQuantities.splice(indexToRemove, 1);

			// Set the correct editorstart URL
			const $next = $('.item-detail .dsp-next');
			const nextUrl = utils.updateParameter('quantity', utils.arrayToQuerystring(this.currentQuantities), $next.attr('href'));
			$next.attr('href', nextUrl);

			const $detail = $('.item-detail');
			this.updatePriceDetail($detail.find('.price-tag'), $detail.find('.price-detail-list'));
			$detail.find('.quantity-total').val(total);
		}

		private showAdorner($img: any, imageUrl?: string) {
			if (imageUrl) {
				$img.attr('src', imageUrl);
				$img.show();
			}
			else
				$img.hide();
		}

		// WEB-5324: Hide constellations on open DSP
		private showDetail(designDetail: core.IDesignDetail, design: core.IDesign, $item: JQuery, keepData: boolean, loadQuantitiesFromURL = false) {
			let optionGroup: core.IDesignProductOptionGroup;
			let option: core.IDesignProductOption;
			// Slick slider doesn't work well with detached objects, so we remove it to add it again when the item is attached
			const $slider = $(".slideshow-container");
			if ($slider.hasClass('slick-slider')) {
				// @ts-ignore
				$slider.slick('unslick');
			}

			// Set current variables
			this.currentProductCode = design.productCode;
			this.currentPvc = design.pvc;
			this.currentPredefinedProductName = design.predefinedProductName;
			this.currentProductName = design.productVariantName;
			this.occasionPackshot = designDetail.occasionPackShot;
			this.purposePackshot = designDetail.purposePackShot;
			this.setHistoryUrl();

			let overlayUrl: string | undefined = design.openDspOverlayUrl;

			let found1 = false;
			let found2 = false;
			if (!keepData) {
				this.currentOption1 = undefined;
				this.currentOption2 = undefined;
			}
			else if (this.currentOption1 || this.currentOption2) {
				// Option valid ?
				if (designDetail.productOptionGroups) {
					for (let l = 0; l < designDetail.productOptionGroups.length; l++) {
						optionGroup = designDetail.productOptionGroups[l];
						if (optionGroup.inDsp !== eXpress.services.OptionInDsp.Hide) {
							if (optionGroup && optionGroup.productOptions && optionGroup.productOptions.length > 0) {
								for (let m = 0; m < optionGroup.productOptions.length; m++) {
									option = optionGroup.productOptions[m];
									// An option can either be exactly the same
									if (this.currentOption1 && option.code.toLowerCase() === this.currentOption1.code) {
										found1 = true;
										if (option.openDspOverlayUrl)
											overlayUrl = option.openDspOverlayUrl;
										break;
									}
									if (this.currentOption2 && option.code.toLowerCase() === this.currentOption2.code) {
										found2 = true;
										break;
									}

									// Or it can be in the same alternativeoptiongroup
									if (this.currentOption1 && option.alternativeOptionGroup === this.currentOption1.alternativeOptionGroup) {
										found1 = true;
										this.currentOption1.code = option.code.toLowerCase();
										this.currentOption1.price = option.price;
										this.currentOption1.name = option.name;
										this.currentOption1.optionGroup = optionGroup.code;
										if (option.openDspOverlayUrl)
											overlayUrl = option.openDspOverlayUrl;
										break;
									}
									if (this.currentOption2 && option.alternativeOptionGroup === this.currentOption2.alternativeOptionGroup) {
										found2 = true;
										this.currentOption2.code = option.code.toLowerCase();
										this.currentOption2.price = option.price;
										this.currentOption2.name = option.name;
										this.currentOption2.optionGroup = optionGroup.code;
										break;
									}
								}
							}
						}
						if (found1 && found2)
							break;
					}
				}
				if (!found1) {
					this.currentOption1 = undefined;
				}
				if (!found2) {
					this.currentOption2 = undefined;
				}
			}

			// If we have no options set, we take the default option (if allowed!)
			if (!keepData && this.defaultOptions && this.defaultOptions.length > 0 && (!this.currentOption1 || !this.currentOption2)) {
				if (designDetail.productOptionGroups) {
					for (let l = 0; l < designDetail.productOptionGroups.length; l++) {
						optionGroup = designDetail.productOptionGroups[l];
						if (optionGroup.inDsp !== eXpress.services.OptionInDsp.Hide) {
							if (optionGroup && optionGroup.productOptions && optionGroup.productOptions.length > 0) {
								for (let m = 0; m < optionGroup.productOptions.length; m++) {
									option = optionGroup.productOptions[m];
									const optionCode: string = option.code.toLowerCase();
									// Is the optionCode in the defaultOptions ?
									let found3 = false;
									for (let m = 0; m < this.defaultOptions.length; m++) {
										if (optionCode === this.defaultOptions[m].toLowerCase()) {
											found3 = true;
											break;
										}
									}
									if (found3) {
										// The code was found in the defaultOptions list, now use it!
										if (optionGroup.inDsp === eXpress.services.OptionInDsp.Icons && !this.currentOption1) {
											this.currentOption1 = new CurrentOption();
											this.currentOption1.code = optionCode.toLowerCase();
											this.currentOption1.alternativeOptionGroup = option.alternativeOptionGroup;
											overlayUrl = option.openDspOverlayUrl;
										}
										else if (optionGroup.inDsp === eXpress.services.OptionInDsp.Dropdown && !this.currentOption2) {
											this.currentOption2 = new CurrentOption();
											this.currentOption2.code = optionCode.toLowerCase();
											this.currentOption2.alternativeOptionGroup = option.alternativeOptionGroup;
										}
									}
								}
							}
						}
						if (found1 && found2)
							break;
					}
				}
			}

			// An optiongroup can be set -> Take options from that one
			if (!keepData && this.optionGroup && (!this.currentOption1 || !this.currentOption2)) {
				if (designDetail.productOptionGroups) {
					for (let l = 0; l < designDetail.productOptionGroups.length; l++) {
						optionGroup = designDetail.productOptionGroups[l];
						if (optionGroup.code.toLowerCase() === this.optionGroup) {
							if (optionGroup && optionGroup.productOptions && optionGroup.productOptions.length > 0) {
								let selectedOption: core.IDesignProductOption | null = null;
								for (let m = 0; m < optionGroup.productOptions.length; m++) {
									option = optionGroup.productOptions[m];
									if (option.defaultProductOption) {
										selectedOption = option;
									}
								}

								if (!selectedOption)
									selectedOption = optionGroup.productOptions[0];

								if (optionGroup.inDsp === eXpress.services.OptionInDsp.Icons && !this.currentOption1) {
									this.currentOption1 = new CurrentOption();
									this.currentOption1.code = selectedOption.code.toLowerCase();
									this.currentOption1.price = selectedOption.price;
									this.currentOption1.optionGroup = optionGroup.code;
									this.currentOption1.alternativeOptionGroup = selectedOption.alternativeOptionGroup;
									overlayUrl = selectedOption.openDspOverlayUrl;
								}
								else if (optionGroup.inDsp === eXpress.services.OptionInDsp.Dropdown && !this.currentOption2) {
									this.currentOption2 = new CurrentOption();
									this.currentOption2.code = selectedOption.code.toLowerCase();
									this.currentOption2.price = selectedOption.price;
									this.currentOption2.optionGroup = optionGroup.code;
									this.currentOption2.alternativeOptionGroup = selectedOption.alternativeOptionGroup;
								}
							}

							break;
						}
					}
				}
			}

			const $detail = $(".item-detail").detach();
			const wasAlreadyOpen = $detail.hasClass('visible');
			const $information = $detail.find('.item-information');
			const $usps = $information.find('.usps');
			$usps.html('');

			// We clicked from within the detail screen, set the item to the currently active tile
			if (!$item.hasClass('item'))
				$item = $('.item.active');

			// Modify the item
			$('.item.active').removeClass('active');
			$item.addClass('active');
			$item.find('.item-filler').removeClass('u-hide');

			// The title on the right
			if (design.productCategory) {
				const $h2 = $detail.find('.productcategory-name');
				$h2.html(design.productCategory.name);
				$h2.attr('original', design.productCategory.name);
			}

			// Modify the detail
			$detail.removeClass();
			$detail.addClass('item-detail visible productcode-'
				+ eXpress.utils.makeCssClass(design.productCode)
				+ ' productcategorycode-' + eXpress.utils.makeCssClass(design.productCategoryCode)
				+ ' productcategorygroupcode-' + eXpress.utils.makeCssClass(design.productCategoryGroupCode));

			// Close the price detail stuff
			if (!keepData) {
				$detail.find('.price-detail-list').hide();
			}

			// Add the adorner
			const $adorner = $detail.find('.adorner-container img');
			this.showAdorner($adorner, overlayUrl);

			// The previews
			const $previewList = $detail.find('.slideshow-container').detach();
			const $previewTemplate = $previewList.children("div").first().detach();
			$previewList.empty();
			if (designDetail.productPreviewImageUrls && designDetail.productPreviewImageUrls.length > 0) {
				for (let i = 0; i < designDetail.productPreviewImageUrls.length; i++) {
					const $previewNew = $previewTemplate.clone();
					const imageContainer = $previewNew.find('img.slideshow-img');
					imageContainer.attr('src', designDetail.productPreviewImageUrls[i] + '?' + this.context.productRevision);
					imageContainer.show();
					$previewList.append($previewNew);
				}
				$detail.find('.item-container-left').prepend($previewList);
			} else {
				// Keep the image container even when there are no product preview images just hide the container
				const $previewNew = $previewTemplate.clone();
				const imageContainer = $previewNew.find('img.slideshow-img');
				imageContainer.hide();
				$previewList.append($previewNew);
				$detail.find('.item-container-left').prepend($previewList);
			}

			// Clone the details template
			$detail.find('.item-detail-choice').remove(); // Remove existing
			const $barTemplate = $detail.find('.item-detail-choice-template');
			$barTemplate.clone().insertBefore($barTemplate).removeClass('item-detail-choice-template').addClass('item-detail-choice').show();

			const $itemDetailChoice = $detail.find('.item-detail-choice');

			// Extra label
			this.setExtraLabelOnDetail($detail[0], design);

			if (this.setDesignActivedForBackGround($itemDetailChoice.parent(), design, '.item-detail-choice-wrapper', eXpress.services.DSPType.OpenDSP))
				$detail.addClass('has-bgcolors');

			// The alternative colors // OpenDSP
			if (this.createTileAlternativeColors($itemDetailChoice, design, '.item-detail-choice-wrapper', eXpress.services.DSPType.OpenDSP))
				$detail.addClass('has-colors');

			/* // WEB-5324: Hide constellations on open DSP
			// Fill in the alternative categories
			if (this.createTileConstellations($itemDetailChoice, design, constellations, '.item-detail-choice-wrapper'))
				$detail.addClass('has-constellations');
			*/

			// Fill in the options
			if (this.createTileOptions($itemDetailChoice, designDetail.productOptionGroups, '.item-detail-choice-wrapper', design.dspOverlayUrl, design.openDspOverlayUrl))
				$detail.addClass('has-options');

			// Fill in the alternative categories
			if (this.createTileProductAlternatives($itemDetailChoice, design, '.item-detail-choice-wrapper', eXpress.services.DSPType.OpenDSP))
				$detail.addClass('has-categories');

			/* Right side */

			// Set the attributes
			let attrFound = false;
			let defaultAttribute: string | undefined = undefined;
			const $header = $detail.find('.has-attributes');
			$header.find('.item-attributes').remove(); // Remove existing
			if (designDetail.attributeDetails && designDetail.attributeDetails.values && designDetail.attributeDetails.values.length > 0) {
				$detail.find('.attribute-name').html(designDetail.attributeDetails.name);

				const $attrTemplate = $detail.find('.item-attributes-template');
				$attrTemplate.find('input.quantity-input').val('');
				for (let ai = 0; ai < designDetail.attributeDetails.values.length; ai++) {
					const $attrNew = $attrTemplate.clone().insertBefore($attrTemplate);
					$attrNew.removeClass('item-attributes-template').addClass('item-attributes').show();

					const attrValue = designDetail.attributeDetails.values[ai];
					$attrNew.find('.size').html(attrValue.name);
					$attrNew.attr('data-attributecode', attrValue.code.toLowerCase());
					if (attrValue.default)
						defaultAttribute = attrValue.code.toLowerCase();
					if (this.currentAttribute && this.currentAttribute.toLowerCase() === attrValue.code.toLowerCase()) {
						attrFound = true;
					}
				}
				if (!attrFound && !defaultAttribute) {
					// No default attribute was set, pick any ?
					defaultAttribute = designDetail.attributeDetails.values[0].code.toLowerCase();
				}

				// always add / remove active class when a panel gets visible / invisible
				$detail.find('.has-attributes').addClass("active").show();
			}
			else {
				// always add / remove active class when a panel gets visible / invisible
				$detail.find('.has-attributes').removeClass("active").hide();
			}
			if (!attrFound)
				this.currentAttribute = defaultAttribute;

			// Quanity needs to be set AFTER the attributes (since the attribute can change)
			if (!keepData) {
				let quantities: Quantity[];
				this.currentQuantities = [];
				if (loadQuantitiesFromURL) {
					quantities = quantityQueryStringToModel(utils.getQueryStringParameter('quantity'));
					if (validateQuantities(quantities, designDetail) && quantities.length > 0) {
						this.currentQuantities = quantities;
					}
				}
				// fall back to default behavior
				if (!this.currentQuantities.length) {
					this.currentQuantities = [new Quantity(this.currentAttribute, designDetail.quantityBreakPriceDetails.defaultQuantityBreaks)];
				}
			}
			// Set the quantity
			if (this.currentAttribute) {
				// Multiple quanities
				let total = 0;
				const indexesToRemove: number[] = [];
				for (let i = 0; i < this.currentQuantities.length; i++) {
					const $quantityBox = $detail.find('.item-attributes[data-attributecode=' + this.currentQuantities[i].attribute + '] input.quantity-input');
					if ($quantityBox.length > 0) {
						$quantityBox.val(this.currentQuantities[i].quantity.toString());
						total += this.currentQuantities[i].quantity;
					}
					else {
						// The attribute that was set it not available for this product
						indexesToRemove.push(i);
					}
				}
				if (indexesToRemove.length > 0) {
					for (let i = 0; i < indexesToRemove.length; i++) {
						this.currentQuantities.splice(indexesToRemove[i], 1);
					}
				}

				$detail.find('.quantity-total').val(total);
				$detail.find('.item-quantity').hide();
			}
			else {
				// Single quantity
				const $quantity = $detail.find('.item-quantity input');
				$quantity.val(this.currentQuantities[0].quantity.toString());

				if (design.hasSets)
					$detail.find('.technical-dsp-quantity-sets').show();
				else
					$detail.find('.technical-dsp-quantity-nosets').show();
			}


			// Set the options to show dropdown if not Icons
			$detail.find('.item-detail-content-header .item-options').remove(); // Remove existing
			let dspOptionFound = false;
			if (designDetail.productOptionGroups && designDetail.productOptionGroups.length > 0) {
				for (let oi = 0; oi < designDetail.productOptionGroups.length; oi++) {
					optionGroup = designDetail.productOptionGroups[oi];
					if (optionGroup.inDsp === eXpress.services.OptionInDsp.Dropdown) {
						const $showInDspTemplate = $detail.find('.item-detail-content-header .item-options-template');
						const $showInDspNew = $showInDspTemplate.clone().insertBefore($showInDspTemplate);
						$showInDspNew.removeClass('item-options-template').addClass('item-options').show();

						// Add the sibling data
						$showInDspNew.attr('optiongroup', optionGroup.code);
						$showInDspNew.attr('siblingdatapagetitle', optionGroup.siblingDataPageTitle || "");
						$showInDspNew.attr('siblingoptionusps', optionGroup.siblingDataOptionUSPs);

						const $showInDspList = $showInDspNew.find('.selectbox-choices');
						const $showInDspLabel = $showInDspList.find('label');
						const $showInDspCurrentSelected = $showInDspNew.find('.selectBox label');
						// Fill in the optiongroup name
						$showInDspNew.find('> label').html(optionGroup.name + ':');
						$showInDspCurrentSelected.html($showInDspLabel.html());
						// the rest
						if (optionGroup.productOptions) {
							for (let oj = 0; oj < optionGroup.productOptions.length; oj++) {
								option = optionGroup.productOptions[oj];
								const $showInDspClone = $showInDspLabel.clone();
								$showInDspClone.html(option.shortName);
								$showInDspClone.attr('data-optioncode', option.code);
								$showInDspClone.attr('data-alternativeoptiongroup', option.alternativeOptionGroup);
								$showInDspClone.attr('data-optionname', option.name);
								$showInDspClone.attr('data-optionprice', option.price);
								$showInDspList.append($showInDspClone);

								if (this.currentOption2 && this.currentOption2.code === option.code.toLowerCase()) {
									dspOptionFound = true;
									$showInDspClone.addClass('checked');
									$showInDspCurrentSelected.html(option.shortName);
									this.setSiblingData($detail, $showInDspClone, $showInDspNew, this.currentOption2);
								}
							}
						}

						if (!dspOptionFound)
							$showInDspLabel.addClass('checked');

						break;
					}
				}
			}
			if (this.currentOption2 && !dspOptionFound)
				this.currentOption2 = undefined;


			// The editor buttons
			let startUrl = designDetail.editorStartLink;
			startUrl = this.modifyStartLinkUrl(startUrl);
			$detail.find('.dsp-next').attr('href', startUrl);

			// The product information
			const $productname = $information.find('.productname');
			$productname.empty();
			if (design.product) {
				const yourChoice = this.pageContext!.labelYourChoice ? this.pageContext.labelYourChoice : "";
				$information.find('.productname').append('<ul class="a-list"><li class="a-list__item">' + yourChoice + ' ' + design.product.name + '</li></ul>');
			}

			if (!$usps.html())
				$usps.html(designDetail.usps);
			$usps.attr('original', designDetail.usps);

			const $dimensions = $information.find('.technical-dimension-usp');
			$dimensions.empty();
			if (design.productCategory.showMeasurements && (designDetail.productDimensions || design.dimensions)) {
				const measurements = this.pageContext!.labelMeasurements ? this.pageContext.labelMeasurements : "";
				const appendedValue = '<li class="a-list__item">' + measurements + ' ' + (designDetail.productDimensions ? designDetail.productDimensions : design.dimensions) + '</li>';
				$dimensions.append(appendedValue);

			}

			const $dspname = $information.find('.dspname');
			$dspname.empty();
			if (design.dspName)
				if (!design.product || design.dspName !== design.product.name)
					$dspname.append('<ul class="a-list"><li class="a-list__item">' + design.dspName + '</li></ul>');

			// The pricing information
			const $priceList = $detail.find('.item-pricing table tbody').detach();
			const $priceTemplate = $priceList.find('tr').first().detach();
			$priceList.empty();
			if (designDetail.quantityBreakPriceDetails && designDetail.quantityBreakPriceDetails.quantityBreaks && designDetail.quantityBreakPriceDetails.quantityBreaks.length > 1) {
				let $previous: JQuery | null = null;
				let $prevAmount: JQuery | null = null;

				let optionPriceToAdd = 0;
				if (this.currentOption1 && this.optionGroup && this.currentOption1.optionGroup.toLowerCase() === this.optionGroup.toLowerCase())
					optionPriceToAdd = this.currentOption1.price;
				else if (this.currentOption2 && this.optionGroup && this.currentOption2.optionGroup.toLowerCase() === this.optionGroup.toLowerCase())
					optionPriceToAdd = this.currentOption2.price;

				for (let j = 0; j < designDetail.quantityBreakPriceDetails.quantityBreaks.length; j++) {
					// Modify the previous to include the upper limit
					if ($previous) {
						$prevAmount = $previous.find('.amount');
						const upperLimit = designDetail.quantityBreakPriceDetails.quantityBreaks[j].break - 1;
						if ($prevAmount.html() !== upperLimit.toString())
							$prevAmount.html($prevAmount.html() + ' - ' + upperLimit.toString());
					}
					const $priceNew = $priceTemplate.clone();
					$priceNew.find('.amount').html(designDetail.quantityBreakPriceDetails.quantityBreaks[j].break.toString());
					const $htmlPrice = $priceNew.find('.price');
					$htmlPrice.attr('data-price', designDetail.quantityBreakPriceDetails.quantityBreaks[j].price);
					$htmlPrice.html(utils.displayPrice(designDetail.quantityBreakPriceDetails.quantityBreaks[j].price + optionPriceToAdd, true, false, this.pageContext));
					$priceList.append($priceNew);
					$previous = $priceNew;
				}

				if ($previous) {
					$prevAmount = $previous.find('.amount');
					$prevAmount.html($prevAmount.html() + ' +');
				}

				$detail.find('.item-pricing table').append($priceList);
			}
			else
				$detail.find('.item-pricing').remove();
			this.updatePriceDetail($detail.find('.price-tag'), $detail.find('.price-detail-list'));

			// The variable pricing information
			if (designDetail.variablePriceDetails) {
				const $varPrice = $detail.find('.variable-price');
				const lis = $varPrice.find('li');
				// The first one is the base amount
				$(lis[0]).html(utils.displayPrice(designDetail.variablePriceDetails.BaseCost, true, false, this.pageContext) + ' - ' + this.pageContext.labelStartingPrice.replace('{0}', designDetail.variablePriceDetails.BaseAmount));
				$(lis[1]).html(this.pageContext.labelExpandableUpTo.replace('{0}', designDetail.variablePriceDetails.MaxPages));
				$(lis[2]).html(utils.displayPrice(designDetail.variablePriceDetails.VariableCost / designDetail.variablePriceDetails.VariableAmount, true, false, this.pageContext) + ' - ' + this.pageContext.labelExtraPage);

				$varPrice.show();
			}
			else {
				$detail.find('.variable-price').hide();
			}

			// The options
			if (designDetail.productOptionGroups && designDetail.productOptionGroups.length > 0) {
				$detail.find('h2.detail-content-options').show();
				const $optionList = $detail.find('.accordion-item.detail-content-options').detach();
				const $optionTemplate = $optionList.children('div').first().detach();
				$optionList.empty();
				for (let k = 0; k < designDetail.productOptionGroups.length; k++) {
					const $optionNew = $optionTemplate.clone();
					const $optionHeader = $optionNew.find('h3').detach();
					const $priceHeader = $optionHeader.find('.option-price').detach();
					const $priceLabel = $optionNew.find('.info-remark').detach();
					const $priceLabel2 = $optionNew.find('.multipe-prices').detach();
					$optionHeader.html(designDetail.productOptionGroups[k].name);
					let hasDifferentPrices = false;
					let hasVarPrice = false;
					const productOptions = designDetail.productOptionGroups[k].productOptions;
					if (!productOptions) throw new Error("ProductOptionGroup has no productOptions");
					const opt = productOptions[0];
					let lowestPriceOption = opt;
					for (let x = 1; x < productOptions.length; x++) {
						const secondOpt = productOptions[x];
						// if VarPrice
						if (opt.varPrice > 0) {
							hasVarPrice = true;
							if (opt.varPrice !== secondOpt.varPrice) {
								hasDifferentPrices = true;
							}
							if (secondOpt.varPrice < lowestPriceOption.varPrice)
								lowestPriceOption = opt;
						} else {
							if (opt.price !== secondOpt.price) {
								hasDifferentPrices = true;
							}
							if (secondOpt.price < lowestPriceOption.price)
								lowestPriceOption = secondOpt;
						}
					}
					// check if there are multiple items in pricelist
					if (hasVarPrice) {
						$priceHeader.html(utils.displayPrice(lowestPriceOption.varPrice, true, true, this.pageContext));
					} else {
						if (hasDifferentPrices) {
							$priceHeader.html(utils.formatString(this.contentManager.getLabel("Label.DspMulti.PriceStartingFrom"), utils.displayPrice(lowestPriceOption.price, true, false, this.pageContext)));
						} else {
							$priceHeader.html(utils.displayPrice(lowestPriceOption.price, true, false, this.pageContext));
						}
					}
					$optionHeader.append($priceHeader);
					$optionNew.empty();
					$optionNew.append($optionHeader);
					$optionNew.append(designDetail.productOptionGroups[k].description);
					if (hasVarPrice)
						$optionNew.append($priceLabel);
					if (hasDifferentPrices)
						$optionNew.append($priceLabel2);
					$optionList.append($optionNew);
				}
				$optionList.insertAfter($detail.find('.accordion-header.detail-content-options'));
			}
			else {
				$detail.find('h2.detail-content-options').hide();
			}
			// The delivery details
			if (designDetail.shipmentDetails.HideAllShipmentDetails) {
				$detail.find('.technical-shipmentdetails').addClass('u-hide');
				$detail.find('.technical-hideshipmentdetails').removeClass('u-hide');
			}
			else {
				$detail.find('.technical-shipmentdetails').removeClass('u-hide');
				$detail.find('.technical-hideshipmentdetails').addClass('u-hide');
				$detail.find('.delivery-item2 .info').html(designDetail.shipmentDetails.LastDeliveryOn);
				$detail.find('.delivery-item3 .info').html(designDetail.shipmentDetails.ShipmentPrice);
			}

			// Replace the social icons URLs & Images
			$detail.find('.social').remove();
			const $socialTemplate = $detail.find('.social-template');
			const social = $socialTemplate.clone();
			let socialHtml = social.html();
			socialHtml = socialHtml.replace(/SOCIALIMAGE/g, encodeURIComponent(this.pageContext.cdn + '/products/' + design.packshotUrl + "?" + this.context.productRevision));
			social.html(socialHtml);
			social.insertBefore($socialTemplate).removeClass('social-template').addClass('social').show();


			// Actually show the detail block
			const $nextElement = this.checkNextElement($item);
			if ($nextElement)
				$detail.hide().insertBefore(this.checkNextElement($item));
			else
				this.dspItemList.append($detail.hide());

			$detail.show();

			this.suppressScrollToAccordion = true;

			const $contentAccordions = $detail.find(".item-detail-content-accordions");
			if ($contentAccordions.data("ui-accordion"))
				$contentAccordions.accordion("destroy");

			$contentAccordions.accordion({
				heightStyle: "content",
				collapsible: true,
				active: 0,
				header: ".accordion-header.active", // always add / remove active class when a panel gets visible / invisible
				activate: (e, ui) => {
					this.accordionTabActivated(ui);
				}
			});

			// @ts-ignore
			$slider.slick({
				slidesToShow: 1,
				infinite: true
			});

			if (!keepData) {
				$('html,body').animate({ scrollTop: $detail.offset()!.top }, 'fast');
			}
		}

		private repositionDetail(): void {
			const $detail = $(".item-detail");
			const $item = $('.item.active');
			if ($item.length > 0) {
				$detail.detach();
				const $nextElement = this.checkNextElement($item);
				if ($nextElement)
					$detail.hide().insertBefore(this.checkNextElement($item));
				else
					this.dspItemList.append($detail.hide());
				$detail.show();
			}
			else {
				$detail.detach();
				this.dspItemList.append($detail.hide());
			}
		}

		private checkNextElement($item: any): any {
			const currentTop = $item.offset().top;
			const $next = $item.next();
			if ($next.length) {
				if (currentTop < $next.offset().top) {
					return $next;
				}
				else {
					return this.checkNextElement($next);
				}
			}
			else {
				return null;
			}
		}

		private setHistoryUrl(): void {
			// construct the URL
			let url = '';

			if (this.mainProductCategoryGroupCode)
				url += '&pcg=' + this.mainProductCategoryGroupCode.toLowerCase();

			// Add the different filters
			if (this.occasion)
				url += '&occ=' + this.occasion.toLowerCase();
			if (this.purpose)
				url += '&purpose=' + this.purpose.toLowerCase();
			if (this.theme)
				url += '&theme=' + this.theme.toLowerCase();
			if (this.options)
				url += '&options=' + this.options.toLowerCase();
			if (this.productCode && this.productCode.length > 0)
				url += '&p=' + this.productCode.sort().join(',').toLowerCase();
			if (this.orientation)
				url += '&or=' + this.orientation.toLowerCase();
			if (this.predefinedProductCategory && this.predefinedProductCategory.length > 0)
				url += '&ds=' + this.predefinedProductCategory.sort().join(',').toLowerCase();
			if (this.searchColor && this.searchColor.length > 0)
				url += '&sc=' + this.searchColor.sort().join(',').toLowerCase();
			if (this.imageCount && this.imageCount.length > 0)
				url += '&ic=' + this.imageCount.join(',').toLowerCase();
			if (this.price && this.price.length > 0)
				url += '&pr=' + this.price.join(',').toLowerCase();
			if (this.ownDesign)
				url += '&cod=true';
			if (this.gender)
				url += '&g=' + this.gender.toLowerCase();

			if (this.currentProductCode)
				url += '&cpc=' + this.currentProductCode.toLowerCase();
			if (this.currentPredefinedProductName)
				url += '&cppn=' + this.currentPredefinedProductName.toLowerCase();
			if (this.crossSellFrom)
				url += '&crossSellFrom=' + this.crossSellFrom.toLowerCase();
			if (this.currentAttribute)
				url += '&attr=' + this.currentAttribute.toLowerCase();
			if (this.sortMethod)
				url += '&sortmethod=' + this.sortMethod.toLowerCase();
			if (this.designGroup)
				url += '&dg=' + this.designGroup.toLowerCase();

			if (this.defaultOptions && this.defaultOptions.length > 0)
				url += '&options=' + this.defaultOptions.sort().join(',').toLowerCase();

			if (this.optionGroup)
				url += '&optiongroup=' + this.optionGroup.toLowerCase();

			if (eXpress.utils.getQueryStringParameter("debug"))
				url += '&debug=true';

			const quantity = utils.getQueryStringParameter('quantity');
			if (quantity) {
				url += '&quantity=' + quantity;
			}

			// Replace the first & by a ?
			if (url.length > 0)
				url = '?' + url.substr(1);

			if (historyJs.replaceState) {
				historyJs.replaceState(null, "", url);
			}
		}

		private updateFilterCount($labelList: JQuery, countList: services.IDesignFilterItemCount[]) {

			$labelList.each(function () {
				const $label = $(this);
				const code = $label.attr('data-sp-filter-tag') || "";

				// Find the value in the API supplied data
				let found = false;
				$.each(countList, (index, value) => {
					if (value && value.Name && value.Name.toLowerCase() === code.toLowerCase()) {
						$label.find('.filter-amount').html(value.Count.toString());
						if (value.Count === 0)
							$label.addClass('disabled');
						else
							$label.removeClass('disabled');
						found = true;
						return false;
					}
				});
				if (!found) {
					$label.find('.filter-amount').html('(0)');
					$label.addClass('disabled');
				}
			});
		}

		private accordionTabActivated($ui: any): void {
			if (this.suppressScrollToAccordion) {
				this.suppressScrollToAccordion = false;
				return;
			}

			if ($ui.newHeader && $ui.newHeader.length > 0) {
				const $elem = $ui.newHeader;
				const $window = $(window);

				const docViewTop = $(window).scrollTop()! + this.headerHeight; // Can't see behind the header
				const docViewBottom = docViewTop + $window.height()!;

				const elemTop = $elem.offset().top;

				if (elemTop < docViewTop || elemTop > docViewBottom) {
					$('html,body').animate({ scrollTop: $elem.offset().top - this.headerHeight }, 'slow');
				}
			}
		}

		private validateInput() {
			// We need at least 1 quantity field to be > 0
			if (this.currentAttribute) {
				let total = 0;
				for (let i = 0; i < this.currentQuantities.length; i++) {
					total += this.currentQuantities[i].quantity;
				}
				if (total <= 0) {
					this.flagInputAsInvalid($('.item-detail.visible .item-attributes .quantity-input'));
					return false;
				}
			} else {
				// this was partially implied. returning undefined on the jQuery handler gave a result no different from returning true.
				// I assume that was not intentional
				const currentQuantity = this.currentQuantities[0];
				return !!(currentQuantity && currentQuantity.quantity > 0);
			}
		}

		private flagInputAsInvalid($boxes: any) {
			$boxes.css('border', '1px solid red');
			setTimeout(function () { $boxes.animate({ borderTopColor: '#c4c2d1', borderRightColor: '#c4c2d1', borderBottomColor: '#c4c2d1', borderLeftColor: '#c4c2d1' }, 500); }, 300);
		}

		private modifyStartLinkUrl(url: string) {
			if (this.occasion)
				url = utils.updateParameter('occ', this.occasion, url);
			if (this.theme)
				url = utils.updateParameter('theme', this.theme, url);
			if (this.options)
				url = utils.updateParameter('options', this.options, url);
			if (this.purpose)
				url = utils.updateParameter('purpose', this.purpose, url);
			if (this.occasionPackshot)
				url = utils.updateParameter('occpackshot', this.occasionPackshot, url);
			if (this.purposePackshot)
				url = utils.updateParameter('purposepackshot', this.purposePackshot, url);
			if (this.productCode && this.productCode.length > 0)
				url = utils.updateParameter('p', this.productCode.sort().join(',').toLowerCase(), url);
			if (this.orientation)
				url = utils.updateParameter('or', this.orientation.toLowerCase(), url);
			if (this.predefinedProductCategory && this.predefinedProductCategory.length > 0)
				url = utils.updateParameter('ds', this.predefinedProductCategory.sort().join(',').toLowerCase(), url);
			if (this.searchColor && this.searchColor.length > 0)
				url = utils.updateParameter('sc', this.searchColor.sort().join(',').toLowerCase(), url);
			if (this.imageCount && this.imageCount.length > 0)
				url = utils.updateParameter('ic', this.imageCount.join(',').toLowerCase(), url);
			if (this.price && this.price.length > 0)
				url = utils.updateParameter('pr', this.price.sort().join(',').toLowerCase(), url);
			if (this.ownDesign)
				url = utils.updateParameter('cod', 'true', url);
			if (this.currentProductCode)
				url = utils.updateParameter('cpc', this.currentProductCode.toLowerCase(), url);
			if (this.currentPredefinedProductName)
				url = utils.updateParameter('cppn', this.currentPredefinedProductName.toLowerCase(), url);
			if (this.currentCartId)
				url = utils.updateParameter('cartid', this.currentCartId.toLowerCase(), url);
			if (this.currentAttribute && this.currentProductCode)
				url = utils.updateParameter('pvc', this.currentProductCode.toLowerCase() + '_' + this.currentAttribute.toLowerCase(), url);
			if (this.gender)
				url = utils.updateParameter('g', this.gender, url);
			if (this.crossSellFrom)
				url = utils.updateParameter('crossSellFrom', this.crossSellFrom, url);

			const allOptions = [this.currentOption1, this.currentOption2].filter(function (val) { return (val && val.code); }).map(v => v!.code).join(',');
			if (allOptions !== '')
				url += '&options=' + allOptions;
			url += '&quantity=' + utils.arrayToQuerystring(this.currentQuantities);

			return url;
		}
	}

	$(function () {
		const services = new eXpress.services.Services(eXpress.core.context);

		const deps: IDspAppDependencies = {
			orderService: new eXpress.services.OrderService(eXpress.core.context),
			contentService: new eXpress.services.ContentService(eXpress.core.context)
		};
		const app = new DspApp(deps, services, eXpress.core.context, pageContext as core.IDspMultiProductPageContext);
		app.start();
	});
}
